/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type AuthType = {
  __typename?: 'AuthType';
  token: Scalars['String']['output'];
  user: UserType;
};

export type BlueprintAssetInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fullHash: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  waveForm?: InputMaybe<WaveFormInput>;
};

export type BlueprintCommunityStatusType = {
  __typename?: 'BlueprintCommunityStatusType';
  blocked: Scalars['Boolean']['output'];
  canModerate: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
};

export type BlueprintConsentInput = {
  licenseConfirmed: Scalars['Boolean']['input'];
  policyVersion: Scalars['String']['input'];
  rightsConfirmed: Scalars['Boolean']['input'];
};

export type BlueprintDownloadType = {
  __typename?: 'BlueprintDownloadType';
  fileName: Scalars['String']['output'];
  fullHash: Scalars['String']['output'];
  presignedUrl: Scalars['String']['output'];
  revisionId: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type BlueprintFilterInput = {
  blueprintType?: InputMaybe<BlueprintKind>;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  favorites?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  stockOnly?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BlueprintFinalizeType = {
  __typename?: 'BlueprintFinalizeType';
  blueprint: Maybe<BlueprintType>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** A plug-in preset or an effect chain */
export type BlueprintKind =
  | 'fxChain'
  | 'preset';

export type BlueprintMetadataInput = {
  blueprintType: BlueprintKind;
  dawVersion: Scalars['String']['input'];
  description: Scalars['String']['input'];
  pluginName?: InputMaybe<Scalars['String']['input']>;
  pluginVersion?: InputMaybe<Scalars['String']['input']>;
  requirements: Scalars['String']['input'];
  stockOnly: Scalars['Boolean']['input'];
  tags: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type BlueprintModerationAssetType = {
  __typename?: 'BlueprintModerationAssetType';
  blocked: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  fullHash: Scalars['String']['output'];
  kind: Scalars['String']['output'];
};

export type BlueprintModerationCaseType = {
  __typename?: 'BlueprintModerationCaseType';
  assets: Array<BlueprintModerationAssetType>;
  creatorId: Scalars['String']['output'];
  creatorName: Scalars['String']['output'];
  history: Array<BlueprintModerationEventType>;
  id: Scalars['ID']['output'];
  ownerBlocked: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
  restrictionReason: Scalars['String']['output'];
  state: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BlueprintModerationEventType = {
  __typename?: 'BlueprintModerationEventType';
  action: Scalars['String']['output'];
  actorId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  reason: Scalars['String']['output'];
};

export type BlueprintPageType = {
  __typename?: 'BlueprintPageType';
  items: Array<BlueprintType>;
  total: Scalars['Int']['output'];
};

export type BlueprintReportType = {
  __typename?: 'BlueprintReportType';
  _id: Scalars['ID']['output'];
  blueprintId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  kind: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  status: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type BlueprintType = {
  __typename?: 'BlueprintType';
  _id: Scalars['ID']['output'];
  blueprintType: BlueprintKind;
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  creatorName: Scalars['String']['output'];
  daw: Scalars['String']['output'];
  dawVersion: Scalars['String']['output'];
  description: Scalars['String']['output'];
  downloadCount: Scalars['Int']['output'];
  favoriteCount: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  license: Maybe<Scalars['String']['output']>;
  moderationReason: Maybe<Scalars['String']['output']>;
  moderationState: Scalars['String']['output'];
  pluginName: Scalars['String']['output'];
  pluginVersion: Scalars['String']['output'];
  policyVersion: Maybe<Scalars['String']['output']>;
  previewUrl: Maybe<Scalars['String']['output']>;
  requirements: Scalars['String']['output'];
  revisionId: Scalars['String']['output'];
  sharingEnabled: Scalars['Boolean']['output'];
  stockOnly: Scalars['Boolean']['output'];
  tags: Array<Scalars['String']['output']>;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  waveForm: Maybe<WaveForm>;
};

export type BlueprintUpdateStatusType = {
  __typename?: 'BlueprintUpdateStatusType';
  available: Scalars['Boolean']['output'];
  blueprintId: Scalars['String']['output'];
  version: Maybe<Scalars['Int']['output']>;
  versionId: Maybe<Scalars['String']['output']>;
};

export type BlueprintUploadPrepareType = {
  __typename?: 'BlueprintUploadPrepareType';
  id: Scalars['ID']['output'];
  uploads: Array<BlueprintUploadType>;
  version: Scalars['Int']['output'];
  versionId: Scalars['String']['output'];
};

export type BlueprintUploadType = {
  __typename?: 'BlueprintUploadType';
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  presignedUrl: Scalars['String']['output'];
};

export type BlueprintVersionSummaryType = {
  __typename?: 'BlueprintVersionSummaryType';
  _id: Scalars['ID']['output'];
  commitMessage: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type BlueprintVersionType = {
  __typename?: 'BlueprintVersionType';
  _id: Scalars['ID']['output'];
  blueprintId: Scalars['String']['output'];
  commitMessage: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dawVersion: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  legacy: Scalars['Boolean']['output'];
  pluginName: Scalars['String']['output'];
  pluginVersion: Scalars['String']['output'];
  previewUrl: Maybe<Scalars['String']['output']>;
  requirements: Scalars['String']['output'];
  sharingEnabled: Scalars['Boolean']['output'];
  stockOnly: Scalars['Boolean']['output'];
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  waveForm: Maybe<WaveForm>;
};

export type Board = {
  __typename?: 'Board';
  _id: Scalars['ID']['output'];
  columns: Array<BoardColumn>;
  createdAt: Scalars['DateTime']['output'];
  memberIds: Array<Scalars['ID']['output']>;
  members: Array<Maybe<UserType>>;
  name: Scalars['String']['output'];
  ownerId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BoardCard = {
  __typename?: 'BoardCard';
  _id: Scalars['ID']['output'];
  addedAt: Scalars['DateTime']['output'];
  addedBy: Scalars['ID']['output'];
  position: Scalars['Float']['output'];
  project: Maybe<ProjectType>;
  projectId: Scalars['ID']['output'];
};

export type BoardCardCreateInput = {
  afterCardId?: InputMaybe<Scalars['ID']['input']>;
  boardId: Scalars['ID']['input'];
  columnId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

export type BoardCardDeleteInput = {
  boardId: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
};

export type BoardCardMoveInput = {
  afterCardId?: InputMaybe<Scalars['ID']['input']>;
  boardId: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
  toColumnId: Scalars['ID']['input'];
};

export type BoardColumn = {
  __typename?: 'BoardColumn';
  _id: Scalars['ID']['output'];
  cards: Array<BoardCard>;
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
};

export type BoardColumnCreateInput = {
  afterColumnId?: InputMaybe<Scalars['ID']['input']>;
  boardId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type BoardColumnDeleteInput = {
  boardId: Scalars['ID']['input'];
  columnId: Scalars['ID']['input'];
};

export type BoardColumnMoveInput = {
  afterColumnId?: InputMaybe<Scalars['ID']['input']>;
  boardId: Scalars['ID']['input'];
  columnId: Scalars['ID']['input'];
};

export type BoardColumnUpdateInput = {
  boardId: Scalars['ID']['input'];
  columnId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type BoardCreateInput = {
  name: Scalars['String']['input'];
};

export type BoardDeleteInput = {
  id: Scalars['ID']['input'];
};

export type BoardMemberInviteInput = {
  boardId: Scalars['ID']['input'];
  userIdOrEmail: Scalars['String']['input'];
};

export type BoardMemberRemoveInput = {
  boardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type BoardUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type Comment = {
  __typename?: 'Comment';
  _id: Scalars['ID']['output'];
  anchor: Maybe<CommentAnchor>;
  author: Maybe<CommentAuthor>;
  authorId: Scalars['ID']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  editedAt: Maybe<Scalars['DateTime']['output']>;
  fileId: Maybe<Scalars['ID']['output']>;
  parentId: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  replies: Array<Comment>;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  resolvedBy: Maybe<Scalars['ID']['output']>;
  targetId: Scalars['ID']['output'];
  targetType: CommentTargetType;
  updatedAt: Scalars['DateTime']['output'];
  versionNumber: Maybe<Scalars['Int']['output']>;
};

export type CommentAnchor = {
  __typename?: 'CommentAnchor';
  atMs: Scalars['Int']['output'];
  kind: CommentAnchorKind;
};

/** The kind of waveform anchor a comment is attached to */
export type CommentAnchorKind =
  | 'TIMESTAMP';

export type CommentAuthor = {
  __typename?: 'CommentAuthor';
  _id: Scalars['ID']['output'];
  artistName: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  image: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
};

export type CommentCreateInput = {
  atMs?: InputMaybe<Scalars['Int']['input']>;
  body: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  target: CommentTargetInput;
};

export type CommentDeleteInput = {
  commentId: Scalars['ID']['input'];
};

export type CommentReopenInput = {
  commentId: Scalars['ID']['input'];
};

export type CommentResolveInput = {
  commentId: Scalars['ID']['input'];
};

export type CommentTargetInput = {
  projectId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  targetType: CommentTargetType;
  /** Required to create top-level comments. versionNumber is ignored on reads; all versions are returned. */
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** The kind of entity a comment thread is attached to */
export type CommentTargetType =
  | 'PROJECT';

export type CommentUpdateInput = {
  body: Scalars['String']['input'];
  commentId: Scalars['ID']['input'];
};

export type DetectedPluginInput = {
  confidence: Scalars['Float']['input'];
  detectionMethod: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pluginType?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
  vst2Id?: InputMaybe<Scalars['String']['input']>;
};

export type FileDeleteInput = {
  fileName: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type FileDownloadInput = {
  fileId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type FileDownloadUrlType = {
  __typename?: 'FileDownloadUrlType';
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  presignedUrl: Scalars['String']['output'];
};

export type FileMetadataInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fullHash: Scalars['String']['input'];
  quickHash: Scalars['String']['input'];
  replacesFileId?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Float']['input'];
  waveForm?: InputMaybe<WaveFormInput>;
};

export type FileUploadInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fullHash: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  quickHash: Scalars['String']['input'];
  replacesFileId?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Float']['input'];
};

export type FileUploadUrlType = {
  __typename?: 'FileUploadUrlType';
  fullHash: Scalars['String']['output'];
  key: Scalars['String']['output'];
  presignedUrl: Scalars['String']['output'];
  quickHash: Scalars['String']['output'];
  replacesFileId: Maybe<Scalars['String']['output']>;
  uploadRequired: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  blueprintDelete: Scalars['Boolean']['output'];
  blueprintDownload: BlueprintDownloadType;
  blueprintFavoriteSet: BlueprintType;
  blueprintModerate: BlueprintModerationCaseType;
  blueprintModerationAsset: Scalars['String']['output'];
  blueprintPublish: BlueprintFinalizeType;
  blueprintReport: Scalars['Boolean']['output'];
  blueprintUpdate: BlueprintType;
  blueprintUploadPrepare: BlueprintUploadPrepareType;
  blueprintVersionFinalize: BlueprintFinalizeType;
  blueprintVersionPush: BlueprintUploadPrepareType;
  boardCardCreate: BoardCard;
  boardCardDelete: Scalars['Boolean']['output'];
  boardCardMove: BoardCard;
  boardColumnCreate: BoardColumn;
  boardColumnDelete: Scalars['Boolean']['output'];
  boardColumnMove: BoardColumn;
  boardColumnUpdate: BoardColumn;
  /** Create a new board with default columns. */
  boardCreate: Board;
  boardDelete: Scalars['Boolean']['output'];
  boardMemberInvite: Board;
  boardMemberRemove: Board;
  boardUpdate: Board;
  commentCreate: Comment;
  commentDelete: Scalars['Boolean']['output'];
  commentReopen: Comment;
  commentResolve: Comment;
  commentUpdate: Comment;
  fileDelete: Scalars['Boolean']['output'];
  /** Generate a presigned URL for direct file download from S3 */
  fileDownload: FileDownloadUrlType;
  /** Generate a presigned URL for direct file upload to S3. Returns uploadRequired=false when the content already exists (dedup by fullHash). */
  fileUpload: FileUploadUrlType;
  /** Create a new project for the authenticated user */
  projectCreate: ProjectType;
  /** Delete a project owned by the authenticated user */
  projectDelete: Scalars['Boolean']['output'];
  /** Invite a user to collaborate on a project by email */
  projectInvite: ProjectInviteType;
  /** Cancel a pending project invitation (owner only) */
  projectInviteCancel: Scalars['String']['output'];
  /** Accept or decline a project invitation */
  projectInviteRespond: Scalars['Boolean']['output'];
  /** Leave a project as a collaborator */
  projectLeave: Scalars['Boolean']['output'];
  /** Remove a member from a project (owner only, cannot remove yourself) */
  projectMemberRemove: Scalars['Boolean']['output'];
  /** Update an existing project owned by the authenticated user */
  projectUpdate: ProjectType;
  /** Verify uploaded objects and atomically publish a pending version. Safe to retry. */
  projectVersionFinalize: Scalars['Boolean']['output'];
  /** Prepare an unpublished version. Upload files, then call projectVersionFinalize to verify and publish. */
  projectVersionPush: VersionPushResponseType;
  /** Discard pending metadata, or rollback the latest published version and its file references/accounting. Does not delete S3 objects. */
  projectVersionRollback: Scalars['Boolean']['output'];
  /** Create a new user account with email, password, full name, and artist name */
  userCreate: AuthType;
  /** Login with email and password to receive an authentication token */
  userLogin: AuthType;
  /** Authenticate or create user account using OAuth provider (e.g., Google) */
  userOAuth: AuthType;
  /** Update the authenticated user's profile (name and artistName). Requires authentication. */
  userUpdate: UserType;
  /** Update the authenticated user's password. Requires authentication. */
  userUpdatePassword: UserType;
};


export type MutationBlueprintDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationBlueprintDownloadArgs = {
  id: Scalars['String']['input'];
  requestId: InputMaybe<Scalars['String']['input']>;
  versionId: InputMaybe<Scalars['String']['input']>;
};


export type MutationBlueprintFavoriteSetArgs = {
  favorite: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationBlueprintModerateArgs = {
  action: Scalars['String']['input'];
  blockedKinds?: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationBlueprintModerationAssetArgs = {
  id: Scalars['String']['input'];
  kind: Scalars['String']['input'];
};


export type MutationBlueprintPublishArgs = {
  id: Scalars['String']['input'];
};


export type MutationBlueprintReportArgs = {
  appeal?: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  versionId: InputMaybe<Scalars['String']['input']>;
};


export type MutationBlueprintUpdateArgs = {
  consent: BlueprintConsentInput;
  id: Scalars['String']['input'];
  metadata: BlueprintMetadataInput;
};


export type MutationBlueprintUploadPrepareArgs = {
  commitMessage?: Scalars['String']['input'];
  consent: BlueprintConsentInput;
  files: Array<BlueprintAssetInput>;
  metadata: BlueprintMetadataInput;
};


export type MutationBlueprintVersionFinalizeArgs = {
  id: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type MutationBlueprintVersionPushArgs = {
  commitMessage: Scalars['String']['input'];
  consent: BlueprintConsentInput;
  files: Array<BlueprintAssetInput>;
  id: Scalars['String']['input'];
  metadata: BlueprintMetadataInput;
};


export type MutationBoardCardCreateArgs = {
  input: BoardCardCreateInput;
};


export type MutationBoardCardDeleteArgs = {
  input: BoardCardDeleteInput;
};


export type MutationBoardCardMoveArgs = {
  input: BoardCardMoveInput;
};


export type MutationBoardColumnCreateArgs = {
  input: BoardColumnCreateInput;
};


export type MutationBoardColumnDeleteArgs = {
  input: BoardColumnDeleteInput;
};


export type MutationBoardColumnMoveArgs = {
  input: BoardColumnMoveInput;
};


export type MutationBoardColumnUpdateArgs = {
  input: BoardColumnUpdateInput;
};


export type MutationBoardCreateArgs = {
  input: BoardCreateInput;
};


export type MutationBoardDeleteArgs = {
  input: BoardDeleteInput;
};


export type MutationBoardMemberInviteArgs = {
  input: BoardMemberInviteInput;
};


export type MutationBoardMemberRemoveArgs = {
  input: BoardMemberRemoveInput;
};


export type MutationBoardUpdateArgs = {
  input: BoardUpdateInput;
};


export type MutationCommentCreateArgs = {
  input: CommentCreateInput;
};


export type MutationCommentDeleteArgs = {
  input: CommentDeleteInput;
};


export type MutationCommentReopenArgs = {
  input: CommentReopenInput;
};


export type MutationCommentResolveArgs = {
  input: CommentResolveInput;
};


export type MutationCommentUpdateArgs = {
  input: CommentUpdateInput;
};


export type MutationFileDeleteArgs = {
  data: FileDeleteInput;
};


export type MutationFileDownloadArgs = {
  data: FileDownloadInput;
};


export type MutationFileUploadArgs = {
  data: FileUploadInput;
};


export type MutationProjectCreateArgs = {
  data: ProjectCreateInput;
};


export type MutationProjectDeleteArgs = {
  projectId: Scalars['String']['input'];
};


export type MutationProjectInviteArgs = {
  data: ProjectInviteInput;
};


export type MutationProjectInviteCancelArgs = {
  data: ProjectInviteCancelInput;
};


export type MutationProjectInviteRespondArgs = {
  data: ProjectInviteResponseInput;
};


export type MutationProjectLeaveArgs = {
  projectId: Scalars['String']['input'];
};


export type MutationProjectMemberRemoveArgs = {
  data: ProjectMemberRemoveInput;
};


export type MutationProjectUpdateArgs = {
  data: ProjectUpdateInput;
  projectId: Scalars['String']['input'];
};


export type MutationProjectVersionFinalizeArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type MutationProjectVersionPushArgs = {
  data: ProjectVersionPushInput;
  projectId: Scalars['String']['input'];
};


export type MutationProjectVersionRollbackArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type MutationUserCreateArgs = {
  data: UserCreateInput;
};


export type MutationUserLoginArgs = {
  data: UserLoginInput;
};


export type MutationUserOAuthArgs = {
  data: UserOAuthInput;
};


export type MutationUserUpdateArgs = {
  data: UserUpdateInput;
};


export type MutationUserUpdatePasswordArgs = {
  data: UserUpdatePasswordInput;
};

export type OAuthProfileInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  family_name?: InputMaybe<Scalars['String']['input']>;
  given_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
};

export type PaginationInput = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PaginationMetadata = {
  __typename?: 'PaginationMetadata';
  currentPage: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ProjectActivityDay = {
  __typename?: 'ProjectActivityDay';
  count: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
};

export type ProjectActivityFeed = {
  __typename?: 'ProjectActivityFeed';
  items: Array<ProjectActivityItem>;
  pagination: PaginationMetadata;
};

export type ProjectActivityItem = {
  __typename?: 'ProjectActivityItem';
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  project: ProjectActivityProject;
  version: ProjectActivityVersion;
};

export type ProjectActivityProject = {
  __typename?: 'ProjectActivityProject';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Fields supported when sorting project activity */
export type ProjectActivitySortField =
  | 'OCCURRED_AT';

export type ProjectActivitySortInput = {
  direction: SortDirection;
  field: ProjectActivitySortField;
};

export type ProjectActivitySummary = {
  __typename?: 'ProjectActivitySummary';
  activeDays: Scalars['Int']['output'];
  availableYears: Array<Scalars['Int']['output']>;
  currentStreak: Scalars['Int']['output'];
  days: Array<ProjectActivityDay>;
  longestStreak: Scalars['Int']['output'];
  totalContributions: Scalars['Int']['output'];
  trackingStartedAt: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectActivityVersion = {
  __typename?: 'ProjectActivityVersion';
  commitMessage: Scalars['String']['output'];
  createdFileCount: Scalars['Int']['output'];
  deletedFileCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  updatedFileCount: Scalars['Int']['output'];
};

export type ProjectCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectFileType = {
  __typename?: 'ProjectFileType';
  _id: Scalars['ID']['output'];
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fullHash: Scalars['String']['output'];
  quickHash: Scalars['String']['output'];
  replacesFileId: Maybe<Scalars['String']['output']>;
  s3Key: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  waveForm: Maybe<WaveForm>;
};

export type ProjectInviteCancelInput = {
  inviteId: Scalars['String']['input'];
};

export type ProjectInviteInput = {
  email: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  role: ProjectInviteRole;
};

export type ProjectInviteResponseInput = {
  accept: Scalars['Boolean']['input'];
  inviteId: Scalars['String']['input'];
};

/** The roles that may be granted through a project invitation */
export type ProjectInviteRole =
  | 'COLLABORATOR'
  | 'READ_ONLY';

/** The status of a project invitation */
export type ProjectInviteStatus =
  | 'ACCEPTED'
  | 'CANCELLED'
  | 'DECLINED'
  | 'EXPIRED'
  | 'PENDING';

export type ProjectInviteType = {
  __typename?: 'ProjectInviteType';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  invitedBy: Scalars['ID']['output'];
  invitedByEmail: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  role: ProjectMemberRole;
  status: ProjectInviteStatus;
};

export type ProjectMemberRemoveInput = {
  memberId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

/** The role of a project member */
export type ProjectMemberRole =
  | 'COLLABORATOR'
  | 'OWNER'
  | 'READ_ONLY';

export type ProjectMemberType = {
  __typename?: 'ProjectMemberType';
  _id: Scalars['ID']['output'];
  artistName: Scalars['String']['output'];
  joinedAt: Scalars['DateTime']['output'];
  role: ProjectMemberRole;
  userEmail: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type ProjectPluginSummaryType = {
  __typename?: 'ProjectPluginSummaryType';
  confidence: Scalars['Float']['output'];
  detectionCount: Scalars['Float']['output'];
  detectionMethod: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pluginType: Maybe<Scalars['String']['output']>;
  vendor: Maybe<Scalars['String']['output']>;
  vst2Id: Maybe<Scalars['String']['output']>;
};

export type ProjectType = {
  __typename?: 'ProjectType';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  files: Maybe<Array<ProjectFileType>>;
  members: Maybe<Array<ProjectMemberType>>;
  name: Scalars['String']['output'];
  owner: Scalars['ID']['output'];
  ownerUser: Maybe<UserType>;
  previewFile: Maybe<ProjectFileType>;
  tags: Maybe<Array<Scalars['String']['output']>>;
  totalSize: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionCount: Scalars['Int']['output'];
  versionHistory: Maybe<Array<ProjectVersionType>>;
};

export type ProjectUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectVersionPushInput = {
  commitMessage: Scalars['String']['input'];
  deletedFileIds: Array<Scalars['String']['input']>;
  newFiles: Array<FileMetadataInput>;
  plugins?: InputMaybe<Array<DetectedPluginInput>>;
  updatedFiles: Array<FileMetadataInput>;
  /** Must be 2: client verifies publication through projectVersionFinalize. */
  uploadProtocol?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectVersionType = {
  __typename?: 'ProjectVersionType';
  _id: Scalars['ID']['output'];
  commitMessage: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdFiles: Array<Scalars['String']['output']>;
  deletedFiles: Array<Scalars['String']['output']>;
  plugins: Maybe<Array<ProjectPluginSummaryType>>;
  updatedFiles: Array<Scalars['String']['output']>;
  version: Scalars['Float']['output'];
};

export type Query = {
  __typename?: 'Query';
  blueprint: BlueprintType;
  blueprintCommunityStatus: BlueprintCommunityStatusType;
  blueprintModerationCase: BlueprintModerationCaseType;
  blueprintModerationQueue: Array<BlueprintReportType>;
  blueprintTags: Array<Scalars['String']['output']>;
  blueprintUpdates: Array<BlueprintUpdateStatusType>;
  blueprintVersion: BlueprintVersionType;
  blueprintVersions: Array<BlueprintVersionSummaryType>;
  blueprints: BlueprintPageType;
  /** Single board hydrated with columns and cards. */
  board: Board;
  /** Boards the current user is a member of. */
  boards: Array<Board>;
  comments: Array<Comment>;
  /** Paginated project versions published by the authenticated user */
  myProjectActivityFeed: ProjectActivityFeed;
  /** UTC calendar summary of project versions published by the authenticated user */
  myProjectActivitySummary: ProjectActivitySummary;
  /** Returns a single project by ID. Only accessible to project owner or members. */
  project: Maybe<ProjectType>;
  /** List pending, non-expired invitations addressed to the current user. */
  projectInvites: Array<ProjectInviteType>;
  /** List invitations sent for a project. Only the project owner may query. */
  projectInvitesSent: Array<ProjectInviteType>;
  /** Get a specific version of a project with its files. */
  projectVersion: Maybe<ProjectType>;
  /** List all projects owned by or shared with the currently authenticated user */
  projects: Array<ProjectType>;
  /** Get the latest release information for the Electron app */
  releaseLatest: ReleaseLatestType;
  /** Returns the list of known render/export folder names used for audio preview detection */
  renderFolderOptions: Array<Scalars['String']['output']>;
  /** Get the current authenticated user's profile */
  user: UserType;
};


export type QueryBlueprintArgs = {
  id: Scalars['String']['input'];
};


export type QueryBlueprintModerationCaseArgs = {
  id: Scalars['String']['input'];
};


export type QueryBlueprintModerationQueueArgs = {
  offset?: Scalars['Int']['input'];
  reviewed?: Scalars['Boolean']['input'];
};


export type QueryBlueprintTagsArgs = {
  search?: Scalars['String']['input'];
};


export type QueryBlueprintUpdatesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryBlueprintVersionArgs = {
  id: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type QueryBlueprintVersionsArgs = {
  id: Scalars['String']['input'];
};


export type QueryBlueprintsArgs = {
  filter: InputMaybe<BlueprintFilterInput>;
};


export type QueryBoardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommentsArgs = {
  target: CommentTargetInput;
};


export type QueryMyProjectActivityFeedArgs = {
  from: Scalars['DateTime']['input'];
  pagination: PaginationInput;
  sort: InputMaybe<ProjectActivitySortInput>;
  to: Scalars['DateTime']['input'];
};


export type QueryMyProjectActivitySummaryArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryProjectInvitesSentArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryProjectVersionArgs = {
  projectId: Scalars['String']['input'];
  version: Scalars['Float']['input'];
};


export type QueryReleaseLatestArgs = {
  channel: InputMaybe<Scalars['String']['input']>;
};

export type ReleaseLatestType = {
  __typename?: 'ReleaseLatestType';
  channel: Scalars['String']['output'];
  feedUrl: Scalars['String']['output'];
  urls: ReleaseUrlsType;
  version: Scalars['String']['output'];
};

export type ReleaseUrlsType = {
  __typename?: 'ReleaseUrlsType';
  linux: Maybe<Scalars['String']['output']>;
  mac: Maybe<Scalars['String']['output']>;
  win: Maybe<Scalars['String']['output']>;
};

/** Shared ascending or descending list sort direction */
export type SortDirection =
  | 'ASC'
  | 'DESC';

export type StorageUsageByProjectType = {
  __typename?: 'StorageUsageByProjectType';
  fileCount: Scalars['Int']['output'];
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  storageUsed: Scalars['Float']['output'];
};

export type SubscriptionFeaturesType = {
  __typename?: 'SubscriptionFeaturesType';
  storageBytes: Scalars['Float']['output'];
};

/** Subscription status types */
export type SubscriptionStatus =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'PAST_DUE'
  | 'TRIALING'
  | 'UNPAID';

/** Available subscription tiers */
export type SubscriptionTier =
  | 'BASIC'
  | 'ENTERPRISE'
  | 'FREE'
  | 'PRO';

export type UserCreateInput = {
  artistName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UserLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UserOAuthInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['Float']['input']>;
  profile: OAuthProfileInput;
  provider: Scalars['String']['input'];
  providerAccountId: Scalars['String']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type UserSubscriptionDataType = {
  __typename?: 'UserSubscriptionDataType';
  currentPeriodEnd: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart: Maybe<Scalars['DateTime']['output']>;
  daysUntilExpiry: Maybe<Scalars['Int']['output']>;
  features: SubscriptionFeaturesType;
  isActive: Scalars['Boolean']['output'];
  projectBreakdown: Array<StorageUsageByProjectType>;
  status: SubscriptionStatus;
  storageLimit: Scalars['Float']['output'];
  storagePercentageUsed: Scalars['Float']['output'];
  storageUsed: Scalars['Float']['output'];
  stripeCustomerId: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId: Maybe<Scalars['String']['output']>;
  tier: SubscriptionTier;
  trialEnd: Maybe<Scalars['DateTime']['output']>;
  trialStart: Maybe<Scalars['DateTime']['output']>;
};

export type UserType = {
  __typename?: 'UserType';
  _id: Scalars['ID']['output'];
  artistName: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  image: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  subscription: Maybe<UserSubscriptionDataType>;
};

export type UserUpdateInput = {
  artistName?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type UserUpdatePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type VersionPushResponseType = {
  __typename?: 'VersionPushResponseType';
  uploadUrls: Array<FileUploadUrlType>;
  version: ProjectVersionType;
};

export type WaveForm = {
  __typename?: 'WaveForm';
  duration: Scalars['Float']['output'];
  peakCount: Scalars['Float']['output'];
  peaks: Scalars['String']['output'];
};

export type WaveFormInput = {
  duration: Scalars['Float']['input'];
  peakCount: Scalars['Float']['input'];
  peaks: Scalars['String']['input'];
};

export type CacheBoardQueryVariables = Exact<{ [key: string]: never; }>;


export type CacheBoardQueryData = { board: { __typename?: 'Board', _id: string, columns: Array<{ __typename?: 'BoardColumn', _id: string, cards: Array<{ __typename?: 'BoardCard', _id: string }> }> } };

export type CacheCardPositionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CacheCardPositionsQueryData = { board: { __typename?: 'Board', _id: string, columns: Array<{ __typename?: 'BoardColumn', _id: string, cards: Array<{ __typename?: 'BoardCard', _id: string, position: number }> }> } };

export type CacheColumnPositionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CacheColumnPositionsQueryData = { board: { __typename?: 'Board', _id: string, columns: Array<{ __typename?: 'BoardColumn', _id: string, position: number }> } };

export type UpdatePasswordMutationVariables = Exact<{
  data: UserUpdatePasswordInput;
}>;


export type UpdatePasswordMutationData = { userUpdatePassword: { __typename?: 'UserType', _id: string } };

export type BlueprintFieldsFragment = { __typename?: 'BlueprintType', _id: string, title: string, sharingEnabled: boolean, license: string, policyVersion: string, moderationState: string, moderationReason: string, description: string, creatorId: string, creatorName: string, daw: string, blueprintType: BlueprintKind, pluginName: string, pluginVersion: string, fileName: string, dawVersion: string, requirements: string, stockOnly: boolean, tags: Array<string>, revisionId: string, version: number, createdAt: any, downloadCount: number, favoriteCount: number, isFavorite: boolean, isOwner: boolean, thumbnailUrl: string, previewUrl: string, waveForm: { __typename?: 'WaveForm', duration: number, peakCount: number, peaks: string } };

export type BlueprintsQueryVariables = Exact<{
  filter: InputMaybe<BlueprintFilterInput>;
}>;


export type BlueprintsQueryData = { blueprints: { __typename?: 'BlueprintPageType', total: number, items: Array<(
      { __typename?: 'BlueprintType' }
      & BlueprintFieldsFragment
    )> } };

export type BlueprintQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BlueprintQueryData = { blueprint: (
    { __typename?: 'BlueprintType' }
    & BlueprintFieldsFragment
  ) };

export type BlueprintTagsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type BlueprintTagsQueryData = { blueprintTags: Array<string> };

export type BlueprintUploadPrepareMutationVariables = Exact<{
  metadata: BlueprintMetadataInput;
  files: Array<BlueprintAssetInput> | BlueprintAssetInput;
  consent: BlueprintConsentInput;
}>;


export type BlueprintUploadPrepareMutationData = { blueprintUploadPrepare: { __typename?: 'BlueprintUploadPrepareType', versionId: string, version: number, id: string, uploads: Array<{ __typename?: 'BlueprintUploadType', kind: string, fileName: string, contentType: string, presignedUrl: string }> } };

export type BlueprintPublishMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BlueprintPublishMutationData = { blueprintPublish: { __typename?: 'BlueprintFinalizeType', status: string, message: string, blueprint: (
      { __typename?: 'BlueprintType' }
      & BlueprintFieldsFragment
    ) } };

export type BlueprintUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  metadata: BlueprintMetadataInput;
  consent: BlueprintConsentInput;
}>;


export type BlueprintUpdateMutationData = { blueprintUpdate: (
    { __typename?: 'BlueprintType' }
    & BlueprintFieldsFragment
  ) };

export type BlueprintDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BlueprintDeleteMutationData = { blueprintDelete: boolean };

export type BlueprintFavoriteSetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  favorite: Scalars['Boolean']['input'];
}>;


export type BlueprintFavoriteSetMutationData = { blueprintFavoriteSet: (
    { __typename?: 'BlueprintType' }
    & BlueprintFieldsFragment
  ) };

export type BlueprintDownloadMutationVariables = Exact<{
  id: Scalars['String']['input'];
  requestId: InputMaybe<Scalars['String']['input']>;
  versionId: InputMaybe<Scalars['String']['input']>;
}>;


export type BlueprintDownloadMutationData = { blueprintDownload: { __typename?: 'BlueprintDownloadType', fileName: string, revisionId: string, version: number, fullHash: string, size: number, presignedUrl: string } };

export type BlueprintReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  appeal: InputMaybe<Scalars['Boolean']['input']>;
  versionId: InputMaybe<Scalars['String']['input']>;
}>;


export type BlueprintReportMutationData = { blueprintReport: boolean };

export type BlueprintCommunityStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type BlueprintCommunityStatusQueryData = { blueprintCommunityStatus: { __typename?: 'BlueprintCommunityStatusType', blocked: boolean, reason: string, canModerate: boolean } };

export type BlueprintModerationQueueQueryVariables = Exact<{
  reviewed: Scalars['Boolean']['input'];
  offset: Scalars['Int']['input'];
}>;


export type BlueprintModerationQueueQueryData = { blueprintModerationQueue: Array<{ __typename?: 'BlueprintReportType', _id: string, blueprintId: string, userId: string, reason: string, kind: string, status: string, createdAt: any }> };

export type BlueprintModerationCaseFieldsFragment = { __typename?: 'BlueprintModerationCaseType', id: string, title: string, creatorId: string, creatorName: string, state: string, reason: string, ownerBlocked: boolean, restrictionReason: string, status: string, history: Array<{ __typename?: 'BlueprintModerationEventType', action: string, reason: string, actorId: string, createdAt: any }>, assets: Array<{ __typename?: 'BlueprintModerationAssetType', kind: string, fileName: string, fullHash: string, blocked: boolean }> };

export type BlueprintModerationCaseQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BlueprintModerationCaseQueryData = { blueprintModerationCase: (
    { __typename?: 'BlueprintModerationCaseType' }
    & BlueprintModerationCaseFieldsFragment
  ) };

export type BlueprintModerateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  action: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  blockedKinds: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BlueprintModerateMutationData = { blueprintModerate: (
    { __typename?: 'BlueprintModerationCaseType' }
    & BlueprintModerationCaseFieldsFragment
  ) };

export type BlueprintModerationAssetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  kind: Scalars['String']['input'];
}>;


export type BlueprintModerationAssetMutationData = { blueprintModerationAsset: string };

export type BlueprintVersionFieldsFragment = { __typename?: 'BlueprintVersionType', _id: string, blueprintId: string, version: number, commitMessage: string, createdAt: any, createdBy: string, legacy: boolean, sharingEnabled: boolean, pluginName: string, pluginVersion: string, dawVersion: string, requirements: string, stockOnly: boolean, fileName: string, thumbnailUrl: string, previewUrl: string, waveForm: { __typename?: 'WaveForm', duration: number, peakCount: number, peaks: string } };

export type BlueprintVersionsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BlueprintVersionsQueryData = { blueprintVersions: Array<{ __typename?: 'BlueprintVersionSummaryType', _id: string, version: number, commitMessage: string, createdAt: any }> };

export type BlueprintVersionQueryVariables = Exact<{
  id: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
}>;


export type BlueprintVersionQueryData = { blueprintVersion: (
    { __typename?: 'BlueprintVersionType' }
    & BlueprintVersionFieldsFragment
  ) };

export type BlueprintVersionPushMutationVariables = Exact<{
  id: Scalars['String']['input'];
  metadata: BlueprintMetadataInput;
  files: Array<BlueprintAssetInput> | BlueprintAssetInput;
  consent: BlueprintConsentInput;
  commitMessage: Scalars['String']['input'];
}>;


export type BlueprintVersionPushMutationData = { blueprintVersionPush: { __typename?: 'BlueprintUploadPrepareType', id: string, versionId: string, version: number, uploads: Array<{ __typename?: 'BlueprintUploadType', kind: string, fileName: string, contentType: string, presignedUrl: string }> } };

export type BlueprintVersionFinalizeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
}>;


export type BlueprintVersionFinalizeMutationData = { blueprintVersionFinalize: { __typename?: 'BlueprintFinalizeType', status: string, message: string, blueprint: (
      { __typename?: 'BlueprintType' }
      & BlueprintFieldsFragment
    ) } };

export type BlueprintUpdatesQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BlueprintUpdatesQueryData = { blueprintUpdates: Array<{ __typename?: 'BlueprintUpdateStatusType', blueprintId: string, available: boolean, versionId: string, version: number }> };

export type BoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type BoardsQueryData = { boards: Array<{ __typename?: 'Board', _id: string, name: string, members: Array<{ __typename?: 'UserType', _id: string, firstName: string, lastName: string, email: string }>, columns: Array<{ __typename?: 'BoardColumn', _id: string, cards: Array<{ __typename?: 'BoardCard', _id: string }> }> }> };

export type BoardCreateMutationVariables = Exact<{
  input: BoardCreateInput;
}>;


export type BoardCreateMutationData = { boardCreate: { __typename?: 'Board', _id: string, name: string, members: Array<{ __typename?: 'UserType', _id: string, firstName: string, lastName: string, email: string }>, columns: Array<{ __typename?: 'BoardColumn', _id: string, cards: Array<{ __typename?: 'BoardCard', _id: string }> }> } };

export type BoardCardCoreFragment = { __typename?: 'BoardCard', _id: string, projectId: string, position: number, addedAt: any, addedBy: string, project: { __typename?: 'ProjectType', _id: string, name: string, versionCount: number, ownerUser: { __typename?: 'UserType', _id: string, firstName: string, lastName: string } } };

export type BoardColumnCoreFragment = { __typename?: 'BoardColumn', _id: string, name: string, position: number, cards: Array<(
    { __typename?: 'BoardCard' }
    & BoardCardCoreFragment
  )> };

export type BoardCoreFragment = { __typename?: 'Board', _id: string, name: string, ownerId: string, memberIds: Array<string>, createdAt: any, updatedAt: any, members: Array<{ __typename?: 'UserType', _id: string, firstName: string, lastName: string, email: string }>, columns: Array<(
    { __typename?: 'BoardColumn' }
    & BoardColumnCoreFragment
  )> };

export type BoardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BoardQueryData = { board: (
    { __typename?: 'Board' }
    & BoardCoreFragment
  ) };

export type BoardUpdateMutationVariables = Exact<{
  input: BoardUpdateInput;
}>;


export type BoardUpdateMutationData = { boardUpdate: (
    { __typename?: 'Board' }
    & BoardCoreFragment
  ) };

export type BoardColumnCreateMutationVariables = Exact<{
  input: BoardColumnCreateInput;
}>;


export type BoardColumnCreateMutationData = { boardColumnCreate: (
    { __typename?: 'BoardColumn' }
    & BoardColumnCoreFragment
  ) };

export type BoardColumnUpdateMutationVariables = Exact<{
  input: BoardColumnUpdateInput;
}>;


export type BoardColumnUpdateMutationData = { boardColumnUpdate: (
    { __typename?: 'BoardColumn' }
    & BoardColumnCoreFragment
  ) };

export type BoardColumnDeleteMutationVariables = Exact<{
  input: BoardColumnDeleteInput;
}>;


export type BoardColumnDeleteMutationData = { boardColumnDelete: boolean };

export type BoardColumnMoveMutationVariables = Exact<{
  input: BoardColumnMoveInput;
}>;


export type BoardColumnMoveMutationData = { boardColumnMove: (
    { __typename?: 'BoardColumn' }
    & BoardColumnCoreFragment
  ) };

export type BoardCardCreateMutationVariables = Exact<{
  input: BoardCardCreateInput;
}>;


export type BoardCardCreateMutationData = { boardCardCreate: (
    { __typename?: 'BoardCard' }
    & BoardCardCoreFragment
  ) };

export type BoardCardDeleteMutationVariables = Exact<{
  input: BoardCardDeleteInput;
}>;


export type BoardCardDeleteMutationData = { boardCardDelete: boolean };

export type BoardCardMoveMutationVariables = Exact<{
  input: BoardCardMoveInput;
}>;


export type BoardCardMoveMutationData = { boardCardMove: (
    { __typename?: 'BoardCard' }
    & BoardCardCoreFragment
  ) };

export type BoardMemberInviteMutationVariables = Exact<{
  input: BoardMemberInviteInput;
}>;


export type BoardMemberInviteMutationData = { boardMemberInvite: (
    { __typename?: 'Board' }
    & BoardCoreFragment
  ) };

export type BoardMemberRemoveMutationVariables = Exact<{
  input: BoardMemberRemoveInput;
}>;


export type BoardMemberRemoveMutationData = { boardMemberRemove: (
    { __typename?: 'Board' }
    & BoardCoreFragment
  ) };

export type BoardDeleteMutationVariables = Exact<{
  input: BoardDeleteInput;
}>;


export type BoardDeleteMutationData = { boardDelete: boolean };

export type GetCommentsQueryVariables = Exact<{
  target: CommentTargetInput;
}>;


export type GetCommentsQueryData = { comments: Array<{ __typename?: 'Comment', _id: string, targetId: string, parentId: string, versionNumber: number, fileId: string, body: string, authorId: string, createdAt: any, editedAt: any, resolvedAt: any, resolvedBy: string, anchor: { __typename?: 'CommentAnchor', kind: CommentAnchorKind, atMs: number }, author: { __typename?: 'CommentAuthor', _id: string, firstName: string, lastName: string, artistName: string, image: string }, replies: Array<{ __typename?: 'Comment', _id: string, targetId: string, parentId: string, body: string, authorId: string, createdAt: any, editedAt: any, resolvedAt: any, resolvedBy: string, anchor: { __typename?: 'CommentAnchor', kind: CommentAnchorKind, atMs: number }, author: { __typename?: 'CommentAuthor', _id: string, firstName: string, lastName: string, artistName: string, image: string } }> }> };

export type CommentCreateMutationVariables = Exact<{
  input: CommentCreateInput;
}>;


export type CommentCreateMutationData = { commentCreate: { __typename?: 'Comment', _id: string } };

export type CommentUpdateMutationVariables = Exact<{
  input: CommentUpdateInput;
}>;


export type CommentUpdateMutationData = { commentUpdate: { __typename?: 'Comment', _id: string } };

export type CommentDeleteMutationVariables = Exact<{
  input: CommentDeleteInput;
}>;


export type CommentDeleteMutationData = { commentDelete: boolean };

export type CommentResolveMutationVariables = Exact<{
  input: CommentResolveInput;
}>;


export type CommentResolveMutationData = { commentResolve: { __typename?: 'Comment', _id: string } };

export type CommentReopenMutationVariables = Exact<{
  input: CommentReopenInput;
}>;


export type CommentReopenMutationData = { commentReopen: { __typename?: 'Comment', _id: string } };

export type GetMyProjectActivitySummaryQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type GetMyProjectActivitySummaryQueryData = { myProjectActivitySummary: { __typename?: 'ProjectActivitySummary', totalContributions: number, activeDays: number, currentStreak: number, longestStreak: number, availableYears: Array<number>, trackingStartedAt: any, days: Array<{ __typename?: 'ProjectActivityDay', date: any, count: number }> } };

export type GetMyProjectActivityFeedQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  pagination: PaginationInput;
  sort: InputMaybe<ProjectActivitySortInput>;
}>;


export type GetMyProjectActivityFeedQueryData = { myProjectActivityFeed: { __typename?: 'ProjectActivityFeed', items: Array<{ __typename?: 'ProjectActivityItem', id: string, occurredAt: any, project: { __typename?: 'ProjectActivityProject', id: string, name: string }, version: { __typename?: 'ProjectActivityVersion', id: string, number: number, commitMessage: string, createdFileCount: number, updatedFileCount: number, deletedFileCount: number } }>, pagination: { __typename?: 'PaginationMetadata', totalItems: number, totalPages: number, currentPage: number, pageSize: number } } };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQueryData = { projects: Array<{ __typename?: 'ProjectType', _id: string, name: string, versionCount: number, description: string, updatedAt: any, ownerUser: { __typename?: 'UserType', _id: string, firstName: string, lastName: string }, members: Array<{ __typename?: 'ProjectMemberType', artistName: string }>, versionHistory: Array<{ __typename?: 'ProjectVersionType', _id: string, version: number }>, previewFile: { __typename?: 'ProjectFileType', _id: string, waveForm: { __typename?: 'WaveForm', duration: number, peakCount: number, peaks: string } } }> };

export type GetProjectPreviewQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  version: Scalars['Float']['input'];
}>;


export type GetProjectPreviewQueryData = { projectVersion: { __typename?: 'ProjectType', _id: string, previewFile: { __typename?: 'ProjectFileType', _id: string, fileName: string, waveForm: { __typename?: 'WaveForm', duration: number, peakCount: number, peaks: string } } } };

export type GetProjectLibraryFilesQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  version: Scalars['Float']['input'];
}>;


export type GetProjectLibraryFilesQueryData = { projectVersion: { __typename?: 'ProjectType', _id: string, files: Array<{ __typename?: 'ProjectFileType', _id: string, fileName: string, quickHash: string, fullHash: string, uploadedAt: any, size: number, contentType: string, s3Key: string }> } };

export type GetProjectQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetProjectQueryData = { project: { __typename?: 'ProjectType', _id: string, name: string, description: string, tags: Array<string>, owner: string, createdAt: any, updatedAt: any, versionHistory: Array<{ __typename?: 'ProjectVersionType', _id: string, version: number, commitMessage: string, deletedFiles: Array<string>, createdFiles: Array<string>, updatedFiles: Array<string>, createdAt: any, plugins: Array<{ __typename?: 'ProjectPluginSummaryType', name: string, vendor: string, pluginType: string, vst2Id: string, confidence: number, detectionMethod: string, detectionCount: number }> }>, members: Array<{ __typename?: 'ProjectMemberType', _id: string, userId: string, userEmail: string, artistName: string, role: ProjectMemberRole, joinedAt: any }> } };

export type GetProjectVersionQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  version: Scalars['Float']['input'];
}>;


export type GetProjectVersionQueryData = { projectVersion: { __typename?: 'ProjectType', _id: string, name: string, description: string, tags: Array<string>, owner: string, createdAt: any, updatedAt: any, files: Array<{ __typename?: 'ProjectFileType', _id: string, fileName: string, contentType: string, size: number, uploadedAt: any, s3Key: string, quickHash: string, fullHash: string, replacesFileId: string, waveForm: { __typename?: 'WaveForm', duration: number, peakCount: number, peaks: string } }>, versionHistory: Array<{ __typename?: 'ProjectVersionType', _id: string, version: number, commitMessage: string, deletedFiles: Array<string>, createdFiles: Array<string>, updatedFiles: Array<string>, createdAt: any, plugins: Array<{ __typename?: 'ProjectPluginSummaryType', name: string, vendor: string, pluginType: string, vst2Id: string, confidence: number, detectionMethod: string, detectionCount: number }> }>, members: Array<{ __typename?: 'ProjectMemberType', _id: string, userId: string, userEmail: string, role: ProjectMemberRole, joinedAt: any }> } };

export type GetProjectInvitesQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetProjectInvitesQueryData = { projectInvitesSent: Array<{ __typename?: 'ProjectInviteType', _id: string, email: string, status: ProjectInviteStatus, role: ProjectMemberRole, createdAt: any, expiresAt: any }> };

export type GetMyInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyInvitesQueryData = { projectInvites: Array<{ __typename?: 'ProjectInviteType', _id: string, projectName: string, invitedByEmail: string, role: ProjectMemberRole, expiresAt: any }> };

export type CreateProjectMutationVariables = Exact<{
  data: ProjectCreateInput;
}>;


export type CreateProjectMutationData = { projectCreate: { __typename?: 'ProjectType', _id: string, name: string, description: string, tags: Array<string>, createdAt: any, versionHistory: Array<{ __typename?: 'ProjectVersionType', _id: string, version: number, commitMessage: string, deletedFiles: Array<string>, createdFiles: Array<string>, updatedFiles: Array<string>, createdAt: any }> } };

export type UpdateProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  data: ProjectUpdateInput;
}>;


export type UpdateProjectMutationData = { projectUpdate: { __typename?: 'ProjectType', _id: string, name: string, description: string, tags: Array<string>, updatedAt: any } };

export type DeleteProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type DeleteProjectMutationData = { projectDelete: boolean };

export type ProjectVersionPushMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  data: ProjectVersionPushInput;
}>;


export type ProjectVersionPushMutationData = { projectVersionPush: { __typename?: 'VersionPushResponseType', version: { __typename?: 'ProjectVersionType', _id: string }, uploadUrls: Array<{ __typename?: 'FileUploadUrlType', presignedUrl: string, uploadRequired: boolean, key: string, quickHash: string, fullHash: string, replacesFileId: string }> } };

export type ProjectVersionRollbackMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
}>;


export type ProjectVersionRollbackMutationData = { projectVersionRollback: boolean };

export type ProjectVersionFinalizeMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
}>;


export type ProjectVersionFinalizeMutationData = { projectVersionFinalize: boolean };

export type InviteToProjectMutationVariables = Exact<{
  data: ProjectInviteInput;
}>;


export type InviteToProjectMutationData = { projectInvite: { __typename?: 'ProjectInviteType', _id: string, email: string, projectName: string, invitedByEmail: string, role: ProjectMemberRole, status: ProjectInviteStatus, expiresAt: any } };

export type RemoveProjectMemberMutationVariables = Exact<{
  data: ProjectMemberRemoveInput;
}>;


export type RemoveProjectMemberMutationData = { projectMemberRemove: boolean };

export type LeaveProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type LeaveProjectMutationData = { projectLeave: boolean };

export type RespondToInviteMutationVariables = Exact<{
  data: ProjectInviteResponseInput;
}>;


export type RespondToInviteMutationData = { projectInviteRespond: boolean };

export type ProjectInviteCancelMutationVariables = Exact<{
  data: ProjectInviteCancelInput;
}>;


export type ProjectInviteCancelMutationData = { projectInviteCancel: string };

export type FileUploadMutationVariables = Exact<{
  data: FileUploadInput;
}>;


export type FileUploadMutationData = { fileUpload: { __typename?: 'FileUploadUrlType', key: string, presignedUrl: string, quickHash: string, fullHash: string, replacesFileId: string } };

export type FileDownloadMutationVariables = Exact<{
  data: FileDownloadInput;
}>;


export type FileDownloadMutationData = { fileDownload: { __typename?: 'FileDownloadUrlType', presignedUrl: string, fileName: string, contentType: string } };

export type FileDeleteMutationVariables = Exact<{
  data: FileDeleteInput;
}>;


export type FileDeleteMutationData = { fileDelete: boolean };

export type GetRenderFolderOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRenderFolderOptionsQueryData = { renderFolderOptions: Array<string> };

export type GetReleaseLatestQueryVariables = Exact<{
  channel: InputMaybe<Scalars['String']['input']>;
}>;


export type GetReleaseLatestQueryData = { releaseLatest: { __typename?: 'ReleaseLatestType', channel: string, version: string, urls: { __typename?: 'ReleaseUrlsType', mac: string, win: string, linux: string } } };

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileQueryData = { user: { __typename?: 'UserType', artistName: string, firstName: string, lastName: string, email: string } };

export type GetUserProfileMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileMinimalQueryData = { user: { __typename?: 'UserType', _id: string, artistName: string } };

export type GetUserProfileRegisterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileRegisterQueryData = { user: { __typename?: 'UserType', _id: string, firstName: string, lastName: string, artistName: string } };

export type GetUserSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSubscriptionQueryData = { user: { __typename?: 'UserType', _id: string, email: string, firstName: string, lastName: string, subscription: { __typename?: 'UserSubscriptionDataType', tier: SubscriptionTier, status: SubscriptionStatus, isActive: boolean, daysUntilExpiry: number, storageUsed: number, storageLimit: number, storagePercentageUsed: number, stripeCustomerId: string, currentPeriodStart: any, currentPeriodEnd: any, trialStart: any, trialEnd: any, features: { __typename?: 'SubscriptionFeaturesType', storageBytes: number }, projectBreakdown: Array<{ __typename?: 'StorageUsageByProjectType', projectId: string, projectName: string, storageUsed: number, fileCount: number }> } } };

export type UpdateUserProfileMutationVariables = Exact<{
  data: UserUpdateInput;
}>;


export type UpdateUserProfileMutationData = { userUpdate: { __typename?: 'UserType', _id: string } };

export type UserLoginMutationVariables = Exact<{
  data: UserLoginInput;
}>;


export type UserLoginMutationData = { userLogin: { __typename?: 'AuthType', token: string, user: { __typename?: 'UserType', _id: string, email: string, firstName: string, lastName: string, artistName: string, image: string } } };

export type UserCreateMutationVariables = Exact<{
  data: UserCreateInput;
}>;


export type UserCreateMutationData = { userCreate: { __typename?: 'AuthType', token: string, user: { __typename?: 'UserType', _id: string, email: string, firstName: string, lastName: string, artistName: string, image: string } } };

export type UserOAuthMutationVariables = Exact<{
  data: UserOAuthInput;
}>;


export type UserOAuthMutationData = { userOAuth: { __typename?: 'AuthType', token: string, user: { __typename?: 'UserType', _id: string, email: string, firstName: string, lastName: string, artistName: string, image: string } } };

export const BlueprintFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment BlueprintFields on BlueprintType {
  _id
  title
  sharingEnabled
  license
  policyVersion
  moderationState
  moderationReason
  description
  creatorId
  creatorName
  daw
  blueprintType
  pluginName
  pluginVersion
  fileName
  dawVersion
  requirements
  stockOnly
  tags
  revisionId
  version
  createdAt
  downloadCount
  favoriteCount
  isFavorite
  isOwner
  thumbnailUrl
  waveForm {
    duration
    peakCount
    peaks
  }
  previewUrl
}
    `;
export const BlueprintModerationCaseFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment BlueprintModerationCaseFields on BlueprintModerationCaseType {
  id
  title
  creatorId
  creatorName
  state
  reason
  ownerBlocked
  restrictionReason
  status
  history {
    action
    reason
    actorId
    createdAt
  }
  assets {
    kind
    fileName
    fullHash
    blocked
  }
}
    `;
export const BlueprintVersionFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment BlueprintVersionFields on BlueprintVersionType {
  _id
  blueprintId
  version
  commitMessage
  createdAt
  createdBy
  legacy
  sharingEnabled
  pluginName
  pluginVersion
  dawVersion
  requirements
  stockOnly
  fileName
  thumbnailUrl
  previewUrl
  waveForm {
    duration
    peakCount
    peaks
  }
}
    `;
export const BoardCardCoreFragmentDoc = /*#__PURE__*/ gql`
    fragment BoardCardCore on BoardCard {
  _id
  projectId
  position
  addedAt
  addedBy
  project {
    _id
    name
    versionCount
    ownerUser {
      _id
      firstName
      lastName
    }
  }
}
    `;
export const BoardColumnCoreFragmentDoc = /*#__PURE__*/ gql`
    fragment BoardColumnCore on BoardColumn {
  _id
  name
  position
  cards {
    ...BoardCardCore
  }
}
    `;
export const BoardCoreFragmentDoc = /*#__PURE__*/ gql`
    fragment BoardCore on Board {
  _id
  name
  ownerId
  memberIds
  members {
    _id
    firstName
    lastName
    email
  }
  columns {
    ...BoardColumnCore
  }
  createdAt
  updatedAt
}
    `;
export const CacheBoardDocument = /*#__PURE__*/ gql`
    query CacheBoard {
  board(id: "board-1") {
    _id
    columns {
      _id
      cards {
        _id
      }
    }
  }
}
    `;

/**
 * __useCacheBoardQuery__
 *
 * To run a query within a React component, call `useCacheBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCacheBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCacheBoardQuery({
 *   variables: {
 *   },
 * });
 */
export function useCacheBoardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CacheBoardQueryData, CacheBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CacheBoardQueryData, CacheBoardQueryVariables>(CacheBoardDocument, options);
      }
export function useCacheBoardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CacheBoardQueryData, CacheBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CacheBoardQueryData, CacheBoardQueryVariables>(CacheBoardDocument, options);
        }
export function useCacheBoardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CacheBoardQueryData, CacheBoardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CacheBoardQueryData, CacheBoardQueryVariables>(CacheBoardDocument, options);
        }
export type CacheBoardQueryHookResult = ReturnType<typeof useCacheBoardQuery>;
export type CacheBoardLazyQueryHookResult = ReturnType<typeof useCacheBoardLazyQuery>;
export type CacheBoardSuspenseQueryHookResult = ReturnType<typeof useCacheBoardSuspenseQuery>;
export type CacheBoardQueryResult = Apollo.QueryResult<CacheBoardQueryData, CacheBoardQueryVariables>;
export const CacheCardPositionsDocument = /*#__PURE__*/ gql`
    query CacheCardPositions {
  board(id: "board-1") {
    _id
    columns {
      _id
      cards {
        _id
        position
      }
    }
  }
}
    `;

/**
 * __useCacheCardPositionsQuery__
 *
 * To run a query within a React component, call `useCacheCardPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCacheCardPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCacheCardPositionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCacheCardPositionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CacheCardPositionsQueryData, CacheCardPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CacheCardPositionsQueryData, CacheCardPositionsQueryVariables>(CacheCardPositionsDocument, options);
      }
export function useCacheCardPositionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CacheCardPositionsQueryData, CacheCardPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CacheCardPositionsQueryData, CacheCardPositionsQueryVariables>(CacheCardPositionsDocument, options);
        }
export function useCacheCardPositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CacheCardPositionsQueryData, CacheCardPositionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CacheCardPositionsQueryData, CacheCardPositionsQueryVariables>(CacheCardPositionsDocument, options);
        }
export type CacheCardPositionsQueryHookResult = ReturnType<typeof useCacheCardPositionsQuery>;
export type CacheCardPositionsLazyQueryHookResult = ReturnType<typeof useCacheCardPositionsLazyQuery>;
export type CacheCardPositionsSuspenseQueryHookResult = ReturnType<typeof useCacheCardPositionsSuspenseQuery>;
export type CacheCardPositionsQueryResult = Apollo.QueryResult<CacheCardPositionsQueryData, CacheCardPositionsQueryVariables>;
export const CacheColumnPositionsDocument = /*#__PURE__*/ gql`
    query CacheColumnPositions {
  board(id: "board-1") {
    _id
    columns {
      _id
      position
    }
  }
}
    `;

/**
 * __useCacheColumnPositionsQuery__
 *
 * To run a query within a React component, call `useCacheColumnPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCacheColumnPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCacheColumnPositionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCacheColumnPositionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CacheColumnPositionsQueryData, CacheColumnPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CacheColumnPositionsQueryData, CacheColumnPositionsQueryVariables>(CacheColumnPositionsDocument, options);
      }
export function useCacheColumnPositionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CacheColumnPositionsQueryData, CacheColumnPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CacheColumnPositionsQueryData, CacheColumnPositionsQueryVariables>(CacheColumnPositionsDocument, options);
        }
export function useCacheColumnPositionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CacheColumnPositionsQueryData, CacheColumnPositionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CacheColumnPositionsQueryData, CacheColumnPositionsQueryVariables>(CacheColumnPositionsDocument, options);
        }
export type CacheColumnPositionsQueryHookResult = ReturnType<typeof useCacheColumnPositionsQuery>;
export type CacheColumnPositionsLazyQueryHookResult = ReturnType<typeof useCacheColumnPositionsLazyQuery>;
export type CacheColumnPositionsSuspenseQueryHookResult = ReturnType<typeof useCacheColumnPositionsSuspenseQuery>;
export type CacheColumnPositionsQueryResult = Apollo.QueryResult<CacheColumnPositionsQueryData, CacheColumnPositionsQueryVariables>;
export const UpdatePasswordDocument = /*#__PURE__*/ gql`
    mutation UpdatePassword($data: UserUpdatePasswordInput!) {
  userUpdatePassword(data: $data) {
    _id
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutationData, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePasswordMutationData, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePasswordMutationData, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutationData>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutationData, UpdatePasswordMutationVariables>;
export const BlueprintsDocument = /*#__PURE__*/ gql`
    query Blueprints($filter: BlueprintFilterInput) {
  blueprints(filter: $filter) {
    total
    items {
      ...BlueprintFields
    }
  }
}
    ${BlueprintFieldsFragmentDoc}`;

/**
 * __useBlueprintsQuery__
 *
 * To run a query within a React component, call `useBlueprintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBlueprintsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BlueprintsQueryData, BlueprintsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BlueprintsQueryData, BlueprintsQueryVariables>(BlueprintsDocument, options);
      }
export function useBlueprintsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BlueprintsQueryData, BlueprintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BlueprintsQueryData, BlueprintsQueryVariables>(BlueprintsDocument, options);
        }
export function useBlueprintsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BlueprintsQueryData, BlueprintsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BlueprintsQueryData, BlueprintsQueryVariables>(BlueprintsDocument, options);
        }
export type BlueprintsQueryHookResult = ReturnType<typeof useBlueprintsQuery>;
export type BlueprintsLazyQueryHookResult = ReturnType<typeof useBlueprintsLazyQuery>;
export type BlueprintsSuspenseQueryHookResult = ReturnType<typeof useBlueprintsSuspenseQuery>;
export type BlueprintsQueryResult = Apollo.QueryResult<BlueprintsQueryData, BlueprintsQueryVariables>;
export const BlueprintDocument = /*#__PURE__*/ gql`
    query Blueprint($id: String!) {
  blueprint(id: $id) {
    ...BlueprintFields
  }
}
    ${BlueprintFieldsFragmentDoc}`;

/**
 * __useBlueprintQuery__
 *
 * To run a query within a React component, call `useBlueprintQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlueprintQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BlueprintQueryData, BlueprintQueryVariables> & ({ variables: BlueprintQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BlueprintQueryData, BlueprintQueryVariables>(BlueprintDocument, options);
      }
export function useBlueprintLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BlueprintQueryData, BlueprintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BlueprintQueryData, BlueprintQueryVariables>(BlueprintDocument, options);
        }
export function useBlueprintSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BlueprintQueryData, BlueprintQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BlueprintQueryData, BlueprintQueryVariables>(BlueprintDocument, options);
        }
export type BlueprintQueryHookResult = ReturnType<typeof useBlueprintQuery>;
export type BlueprintLazyQueryHookResult = ReturnType<typeof useBlueprintLazyQuery>;
export type BlueprintSuspenseQueryHookResult = ReturnType<typeof useBlueprintSuspenseQuery>;
export type BlueprintQueryResult = Apollo.QueryResult<BlueprintQueryData, BlueprintQueryVariables>;
export const BlueprintTagsDocument = /*#__PURE__*/ gql`
    query BlueprintTags($search: String!) {
  blueprintTags(search: $search)
}
    `;

/**
 * __useBlueprintTagsQuery__
 *
 * To run a query within a React component, call `useBlueprintTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintTagsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useBlueprintTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BlueprintTagsQueryData, BlueprintTagsQueryVariables> & ({ variables: BlueprintTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BlueprintTagsQueryData, BlueprintTagsQueryVariables>(BlueprintTagsDocument, options);
      }
export function useBlueprintTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BlueprintTagsQueryData, BlueprintTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BlueprintTagsQueryData, BlueprintTagsQueryVariables>(BlueprintTagsDocument, options);
        }
export function useBlueprintTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BlueprintTagsQueryData, BlueprintTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BlueprintTagsQueryData, BlueprintTagsQueryVariables>(BlueprintTagsDocument, options);
        }
export type BlueprintTagsQueryHookResult = ReturnType<typeof useBlueprintTagsQuery>;
export type BlueprintTagsLazyQueryHookResult = ReturnType<typeof useBlueprintTagsLazyQuery>;
export type BlueprintTagsSuspenseQueryHookResult = ReturnType<typeof useBlueprintTagsSuspenseQuery>;
export type BlueprintTagsQueryResult = Apollo.QueryResult<BlueprintTagsQueryData, BlueprintTagsQueryVariables>;
export const BlueprintUploadPrepareDocument = /*#__PURE__*/ gql`
    mutation BlueprintUploadPrepare($metadata: BlueprintMetadataInput!, $files: [BlueprintAssetInput!]!, $consent: BlueprintConsentInput!) {
  blueprintUploadPrepare(metadata: $metadata, files: $files, consent: $consent) {
    versionId
    version
    id
    uploads {
      kind
      fileName
      contentType
      presignedUrl
    }
  }
}
    `;
export type BlueprintUploadPrepareMutationFn = Apollo.MutationFunction<BlueprintUploadPrepareMutationData, BlueprintUploadPrepareMutationVariables>;

/**
 * __useBlueprintUploadPrepareMutation__
 *
 * To run a mutation, you first call `useBlueprintUploadPrepareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintUploadPrepareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintUploadPrepareMutation, { data, loading, error }] = useBlueprintUploadPrepareMutation({
 *   variables: {
 *      metadata: // value for 'metadata'
 *      files: // value for 'files'
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useBlueprintUploadPrepareMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintUploadPrepareMutationData, BlueprintUploadPrepareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintUploadPrepareMutationData, BlueprintUploadPrepareMutationVariables>(BlueprintUploadPrepareDocument, options);
      }
export type BlueprintUploadPrepareMutationHookResult = ReturnType<typeof useBlueprintUploadPrepareMutation>;
export type BlueprintUploadPrepareMutationResult = Apollo.MutationResult<BlueprintUploadPrepareMutationData>;
export type BlueprintUploadPrepareMutationOptions = Apollo.BaseMutationOptions<BlueprintUploadPrepareMutationData, BlueprintUploadPrepareMutationVariables>;
export const BlueprintPublishDocument = /*#__PURE__*/ gql`
    mutation BlueprintPublish($id: String!) {
  blueprintPublish(id: $id) {
    status
    message
    blueprint {
      ...BlueprintFields
    }
  }
}
    ${BlueprintFieldsFragmentDoc}`;
export type BlueprintPublishMutationFn = Apollo.MutationFunction<BlueprintPublishMutationData, BlueprintPublishMutationVariables>;

/**
 * __useBlueprintPublishMutation__
 *
 * To run a mutation, you first call `useBlueprintPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintPublishMutation, { data, loading, error }] = useBlueprintPublishMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlueprintPublishMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintPublishMutationData, BlueprintPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintPublishMutationData, BlueprintPublishMutationVariables>(BlueprintPublishDocument, options);
      }
export type BlueprintPublishMutationHookResult = ReturnType<typeof useBlueprintPublishMutation>;
export type BlueprintPublishMutationResult = Apollo.MutationResult<BlueprintPublishMutationData>;
export type BlueprintPublishMutationOptions = Apollo.BaseMutationOptions<BlueprintPublishMutationData, BlueprintPublishMutationVariables>;
export const BlueprintUpdateDocument = /*#__PURE__*/ gql`
    mutation BlueprintUpdate($id: String!, $metadata: BlueprintMetadataInput!, $consent: BlueprintConsentInput!) {
  blueprintUpdate(id: $id, metadata: $metadata, consent: $consent) {
    ...BlueprintFields
  }
}
    ${BlueprintFieldsFragmentDoc}`;
export type BlueprintUpdateMutationFn = Apollo.MutationFunction<BlueprintUpdateMutationData, BlueprintUpdateMutationVariables>;

/**
 * __useBlueprintUpdateMutation__
 *
 * To run a mutation, you first call `useBlueprintUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintUpdateMutation, { data, loading, error }] = useBlueprintUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metadata: // value for 'metadata'
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useBlueprintUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintUpdateMutationData, BlueprintUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintUpdateMutationData, BlueprintUpdateMutationVariables>(BlueprintUpdateDocument, options);
      }
export type BlueprintUpdateMutationHookResult = ReturnType<typeof useBlueprintUpdateMutation>;
export type BlueprintUpdateMutationResult = Apollo.MutationResult<BlueprintUpdateMutationData>;
export type BlueprintUpdateMutationOptions = Apollo.BaseMutationOptions<BlueprintUpdateMutationData, BlueprintUpdateMutationVariables>;
export const BlueprintDeleteDocument = /*#__PURE__*/ gql`
    mutation BlueprintDelete($id: String!) {
  blueprintDelete(id: $id)
}
    `;
export type BlueprintDeleteMutationFn = Apollo.MutationFunction<BlueprintDeleteMutationData, BlueprintDeleteMutationVariables>;

/**
 * __useBlueprintDeleteMutation__
 *
 * To run a mutation, you first call `useBlueprintDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintDeleteMutation, { data, loading, error }] = useBlueprintDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlueprintDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintDeleteMutationData, BlueprintDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintDeleteMutationData, BlueprintDeleteMutationVariables>(BlueprintDeleteDocument, options);
      }
export type BlueprintDeleteMutationHookResult = ReturnType<typeof useBlueprintDeleteMutation>;
export type BlueprintDeleteMutationResult = Apollo.MutationResult<BlueprintDeleteMutationData>;
export type BlueprintDeleteMutationOptions = Apollo.BaseMutationOptions<BlueprintDeleteMutationData, BlueprintDeleteMutationVariables>;
export const BlueprintFavoriteSetDocument = /*#__PURE__*/ gql`
    mutation BlueprintFavoriteSet($id: String!, $favorite: Boolean!) {
  blueprintFavoriteSet(id: $id, favorite: $favorite) {
    ...BlueprintFields
  }
}
    ${BlueprintFieldsFragmentDoc}`;
export type BlueprintFavoriteSetMutationFn = Apollo.MutationFunction<BlueprintFavoriteSetMutationData, BlueprintFavoriteSetMutationVariables>;

/**
 * __useBlueprintFavoriteSetMutation__
 *
 * To run a mutation, you first call `useBlueprintFavoriteSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintFavoriteSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintFavoriteSetMutation, { data, loading, error }] = useBlueprintFavoriteSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      favorite: // value for 'favorite'
 *   },
 * });
 */
export function useBlueprintFavoriteSetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintFavoriteSetMutationData, BlueprintFavoriteSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintFavoriteSetMutationData, BlueprintFavoriteSetMutationVariables>(BlueprintFavoriteSetDocument, options);
      }
export type BlueprintFavoriteSetMutationHookResult = ReturnType<typeof useBlueprintFavoriteSetMutation>;
export type BlueprintFavoriteSetMutationResult = Apollo.MutationResult<BlueprintFavoriteSetMutationData>;
export type BlueprintFavoriteSetMutationOptions = Apollo.BaseMutationOptions<BlueprintFavoriteSetMutationData, BlueprintFavoriteSetMutationVariables>;
export const BlueprintDownloadDocument = /*#__PURE__*/ gql`
    mutation BlueprintDownload($id: String!, $requestId: String, $versionId: String) {
  blueprintDownload(id: $id, requestId: $requestId, versionId: $versionId) {
    fileName
    revisionId
    version
    fullHash
    size
    presignedUrl
  }
}
    `;
export type BlueprintDownloadMutationFn = Apollo.MutationFunction<BlueprintDownloadMutationData, BlueprintDownloadMutationVariables>;

/**
 * __useBlueprintDownloadMutation__
 *
 * To run a mutation, you first call `useBlueprintDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintDownloadMutation, { data, loading, error }] = useBlueprintDownloadMutation({
 *   variables: {
 *      id: // value for 'id'
 *      requestId: // value for 'requestId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useBlueprintDownloadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintDownloadMutationData, BlueprintDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintDownloadMutationData, BlueprintDownloadMutationVariables>(BlueprintDownloadDocument, options);
      }
export type BlueprintDownloadMutationHookResult = ReturnType<typeof useBlueprintDownloadMutation>;
export type BlueprintDownloadMutationResult = Apollo.MutationResult<BlueprintDownloadMutationData>;
export type BlueprintDownloadMutationOptions = Apollo.BaseMutationOptions<BlueprintDownloadMutationData, BlueprintDownloadMutationVariables>;
export const BlueprintReportDocument = /*#__PURE__*/ gql`
    mutation BlueprintReport($id: String!, $reason: String!, $appeal: Boolean, $versionId: String) {
  blueprintReport(
    id: $id
    reason: $reason
    appeal: $appeal
    versionId: $versionId
  )
}
    `;
export type BlueprintReportMutationFn = Apollo.MutationFunction<BlueprintReportMutationData, BlueprintReportMutationVariables>;

/**
 * __useBlueprintReportMutation__
 *
 * To run a mutation, you first call `useBlueprintReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintReportMutation, { data, loading, error }] = useBlueprintReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      appeal: // value for 'appeal'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useBlueprintReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintReportMutationData, BlueprintReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintReportMutationData, BlueprintReportMutationVariables>(BlueprintReportDocument, options);
      }
export type BlueprintReportMutationHookResult = ReturnType<typeof useBlueprintReportMutation>;
export type BlueprintReportMutationResult = Apollo.MutationResult<BlueprintReportMutationData>;
export type BlueprintReportMutationOptions = Apollo.BaseMutationOptions<BlueprintReportMutationData, BlueprintReportMutationVariables>;
export const BlueprintCommunityStatusDocument = /*#__PURE__*/ gql`
    query BlueprintCommunityStatus {
  blueprintCommunityStatus {
    blocked
    reason
    canModerate
  }
}
    `;

/**
 * __useBlueprintCommunityStatusQuery__
 *
 * To run a query within a React component, call `useBlueprintCommunityStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintCommunityStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintCommunityStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useBlueprintCommunityStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BlueprintCommunityStatusQueryData, BlueprintCommunityStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BlueprintCommunityStatusQueryData, BlueprintCommunityStatusQueryVariables>(BlueprintCommunityStatusDocument, options);
      }
export function useBlueprintCommunityStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BlueprintCommunityStatusQueryData, BlueprintCommunityStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BlueprintCommunityStatusQueryData, BlueprintCommunityStatusQueryVariables>(BlueprintCommunityStatusDocument, options);
        }
export function useBlueprintCommunityStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BlueprintCommunityStatusQueryData, BlueprintCommunityStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BlueprintCommunityStatusQueryData, BlueprintCommunityStatusQueryVariables>(BlueprintCommunityStatusDocument, options);
        }
export type BlueprintCommunityStatusQueryHookResult = ReturnType<typeof useBlueprintCommunityStatusQuery>;
export type BlueprintCommunityStatusLazyQueryHookResult = ReturnType<typeof useBlueprintCommunityStatusLazyQuery>;
export type BlueprintCommunityStatusSuspenseQueryHookResult = ReturnType<typeof useBlueprintCommunityStatusSuspenseQuery>;
export type BlueprintCommunityStatusQueryResult = Apollo.QueryResult<BlueprintCommunityStatusQueryData, BlueprintCommunityStatusQueryVariables>;
export const BlueprintModerationQueueDocument = /*#__PURE__*/ gql`
    query BlueprintModerationQueue($reviewed: Boolean!, $offset: Int!) {
  blueprintModerationQueue(reviewed: $reviewed, offset: $offset) {
    _id
    blueprintId
    userId
    reason
    kind
    status
    createdAt
  }
}
    `;

/**
 * __useBlueprintModerationQueueQuery__
 *
 * To run a query within a React component, call `useBlueprintModerationQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintModerationQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintModerationQueueQuery({
 *   variables: {
 *      reviewed: // value for 'reviewed'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBlueprintModerationQueueQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BlueprintModerationQueueQueryData, BlueprintModerationQueueQueryVariables> & ({ variables: BlueprintModerationQueueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BlueprintModerationQueueQueryData, BlueprintModerationQueueQueryVariables>(BlueprintModerationQueueDocument, options);
      }
export function useBlueprintModerationQueueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BlueprintModerationQueueQueryData, BlueprintModerationQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BlueprintModerationQueueQueryData, BlueprintModerationQueueQueryVariables>(BlueprintModerationQueueDocument, options);
        }
export function useBlueprintModerationQueueSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BlueprintModerationQueueQueryData, BlueprintModerationQueueQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BlueprintModerationQueueQueryData, BlueprintModerationQueueQueryVariables>(BlueprintModerationQueueDocument, options);
        }
export type BlueprintModerationQueueQueryHookResult = ReturnType<typeof useBlueprintModerationQueueQuery>;
export type BlueprintModerationQueueLazyQueryHookResult = ReturnType<typeof useBlueprintModerationQueueLazyQuery>;
export type BlueprintModerationQueueSuspenseQueryHookResult = ReturnType<typeof useBlueprintModerationQueueSuspenseQuery>;
export type BlueprintModerationQueueQueryResult = Apollo.QueryResult<BlueprintModerationQueueQueryData, BlueprintModerationQueueQueryVariables>;
export const BlueprintModerationCaseDocument = /*#__PURE__*/ gql`
    query BlueprintModerationCase($id: String!) {
  blueprintModerationCase(id: $id) {
    ...BlueprintModerationCaseFields
  }
}
    ${BlueprintModerationCaseFieldsFragmentDoc}`;

/**
 * __useBlueprintModerationCaseQuery__
 *
 * To run a query within a React component, call `useBlueprintModerationCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintModerationCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintModerationCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlueprintModerationCaseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BlueprintModerationCaseQueryData, BlueprintModerationCaseQueryVariables> & ({ variables: BlueprintModerationCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BlueprintModerationCaseQueryData, BlueprintModerationCaseQueryVariables>(BlueprintModerationCaseDocument, options);
      }
export function useBlueprintModerationCaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BlueprintModerationCaseQueryData, BlueprintModerationCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BlueprintModerationCaseQueryData, BlueprintModerationCaseQueryVariables>(BlueprintModerationCaseDocument, options);
        }
export function useBlueprintModerationCaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BlueprintModerationCaseQueryData, BlueprintModerationCaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BlueprintModerationCaseQueryData, BlueprintModerationCaseQueryVariables>(BlueprintModerationCaseDocument, options);
        }
export type BlueprintModerationCaseQueryHookResult = ReturnType<typeof useBlueprintModerationCaseQuery>;
export type BlueprintModerationCaseLazyQueryHookResult = ReturnType<typeof useBlueprintModerationCaseLazyQuery>;
export type BlueprintModerationCaseSuspenseQueryHookResult = ReturnType<typeof useBlueprintModerationCaseSuspenseQuery>;
export type BlueprintModerationCaseQueryResult = Apollo.QueryResult<BlueprintModerationCaseQueryData, BlueprintModerationCaseQueryVariables>;
export const BlueprintModerateDocument = /*#__PURE__*/ gql`
    mutation BlueprintModerate($id: String!, $action: String!, $reason: String!, $blockedKinds: [String!]) {
  blueprintModerate(
    id: $id
    action: $action
    reason: $reason
    blockedKinds: $blockedKinds
  ) {
    ...BlueprintModerationCaseFields
  }
}
    ${BlueprintModerationCaseFieldsFragmentDoc}`;
export type BlueprintModerateMutationFn = Apollo.MutationFunction<BlueprintModerateMutationData, BlueprintModerateMutationVariables>;

/**
 * __useBlueprintModerateMutation__
 *
 * To run a mutation, you first call `useBlueprintModerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintModerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintModerateMutation, { data, loading, error }] = useBlueprintModerateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      action: // value for 'action'
 *      reason: // value for 'reason'
 *      blockedKinds: // value for 'blockedKinds'
 *   },
 * });
 */
export function useBlueprintModerateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintModerateMutationData, BlueprintModerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintModerateMutationData, BlueprintModerateMutationVariables>(BlueprintModerateDocument, options);
      }
export type BlueprintModerateMutationHookResult = ReturnType<typeof useBlueprintModerateMutation>;
export type BlueprintModerateMutationResult = Apollo.MutationResult<BlueprintModerateMutationData>;
export type BlueprintModerateMutationOptions = Apollo.BaseMutationOptions<BlueprintModerateMutationData, BlueprintModerateMutationVariables>;
export const BlueprintModerationAssetDocument = /*#__PURE__*/ gql`
    mutation BlueprintModerationAsset($id: String!, $kind: String!) {
  blueprintModerationAsset(id: $id, kind: $kind)
}
    `;
export type BlueprintModerationAssetMutationFn = Apollo.MutationFunction<BlueprintModerationAssetMutationData, BlueprintModerationAssetMutationVariables>;

/**
 * __useBlueprintModerationAssetMutation__
 *
 * To run a mutation, you first call `useBlueprintModerationAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintModerationAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintModerationAssetMutation, { data, loading, error }] = useBlueprintModerationAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useBlueprintModerationAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintModerationAssetMutationData, BlueprintModerationAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintModerationAssetMutationData, BlueprintModerationAssetMutationVariables>(BlueprintModerationAssetDocument, options);
      }
export type BlueprintModerationAssetMutationHookResult = ReturnType<typeof useBlueprintModerationAssetMutation>;
export type BlueprintModerationAssetMutationResult = Apollo.MutationResult<BlueprintModerationAssetMutationData>;
export type BlueprintModerationAssetMutationOptions = Apollo.BaseMutationOptions<BlueprintModerationAssetMutationData, BlueprintModerationAssetMutationVariables>;
export const BlueprintVersionsDocument = /*#__PURE__*/ gql`
    query BlueprintVersions($id: String!) {
  blueprintVersions(id: $id) {
    _id
    version
    commitMessage
    createdAt
  }
}
    `;

/**
 * __useBlueprintVersionsQuery__
 *
 * To run a query within a React component, call `useBlueprintVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintVersionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlueprintVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BlueprintVersionsQueryData, BlueprintVersionsQueryVariables> & ({ variables: BlueprintVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BlueprintVersionsQueryData, BlueprintVersionsQueryVariables>(BlueprintVersionsDocument, options);
      }
export function useBlueprintVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BlueprintVersionsQueryData, BlueprintVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BlueprintVersionsQueryData, BlueprintVersionsQueryVariables>(BlueprintVersionsDocument, options);
        }
export function useBlueprintVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BlueprintVersionsQueryData, BlueprintVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BlueprintVersionsQueryData, BlueprintVersionsQueryVariables>(BlueprintVersionsDocument, options);
        }
export type BlueprintVersionsQueryHookResult = ReturnType<typeof useBlueprintVersionsQuery>;
export type BlueprintVersionsLazyQueryHookResult = ReturnType<typeof useBlueprintVersionsLazyQuery>;
export type BlueprintVersionsSuspenseQueryHookResult = ReturnType<typeof useBlueprintVersionsSuspenseQuery>;
export type BlueprintVersionsQueryResult = Apollo.QueryResult<BlueprintVersionsQueryData, BlueprintVersionsQueryVariables>;
export const BlueprintVersionDocument = /*#__PURE__*/ gql`
    query BlueprintVersion($id: String!, $versionId: String!) {
  blueprintVersion(id: $id, versionId: $versionId) {
    ...BlueprintVersionFields
  }
}
    ${BlueprintVersionFieldsFragmentDoc}`;

/**
 * __useBlueprintVersionQuery__
 *
 * To run a query within a React component, call `useBlueprintVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintVersionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useBlueprintVersionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BlueprintVersionQueryData, BlueprintVersionQueryVariables> & ({ variables: BlueprintVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BlueprintVersionQueryData, BlueprintVersionQueryVariables>(BlueprintVersionDocument, options);
      }
export function useBlueprintVersionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BlueprintVersionQueryData, BlueprintVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BlueprintVersionQueryData, BlueprintVersionQueryVariables>(BlueprintVersionDocument, options);
        }
export function useBlueprintVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BlueprintVersionQueryData, BlueprintVersionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BlueprintVersionQueryData, BlueprintVersionQueryVariables>(BlueprintVersionDocument, options);
        }
export type BlueprintVersionQueryHookResult = ReturnType<typeof useBlueprintVersionQuery>;
export type BlueprintVersionLazyQueryHookResult = ReturnType<typeof useBlueprintVersionLazyQuery>;
export type BlueprintVersionSuspenseQueryHookResult = ReturnType<typeof useBlueprintVersionSuspenseQuery>;
export type BlueprintVersionQueryResult = Apollo.QueryResult<BlueprintVersionQueryData, BlueprintVersionQueryVariables>;
export const BlueprintVersionPushDocument = /*#__PURE__*/ gql`
    mutation BlueprintVersionPush($id: String!, $metadata: BlueprintMetadataInput!, $files: [BlueprintAssetInput!]!, $consent: BlueprintConsentInput!, $commitMessage: String!) {
  blueprintVersionPush(
    id: $id
    metadata: $metadata
    files: $files
    consent: $consent
    commitMessage: $commitMessage
  ) {
    id
    versionId
    version
    uploads {
      kind
      fileName
      contentType
      presignedUrl
    }
  }
}
    `;
export type BlueprintVersionPushMutationFn = Apollo.MutationFunction<BlueprintVersionPushMutationData, BlueprintVersionPushMutationVariables>;

/**
 * __useBlueprintVersionPushMutation__
 *
 * To run a mutation, you first call `useBlueprintVersionPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintVersionPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintVersionPushMutation, { data, loading, error }] = useBlueprintVersionPushMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metadata: // value for 'metadata'
 *      files: // value for 'files'
 *      consent: // value for 'consent'
 *      commitMessage: // value for 'commitMessage'
 *   },
 * });
 */
export function useBlueprintVersionPushMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintVersionPushMutationData, BlueprintVersionPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintVersionPushMutationData, BlueprintVersionPushMutationVariables>(BlueprintVersionPushDocument, options);
      }
export type BlueprintVersionPushMutationHookResult = ReturnType<typeof useBlueprintVersionPushMutation>;
export type BlueprintVersionPushMutationResult = Apollo.MutationResult<BlueprintVersionPushMutationData>;
export type BlueprintVersionPushMutationOptions = Apollo.BaseMutationOptions<BlueprintVersionPushMutationData, BlueprintVersionPushMutationVariables>;
export const BlueprintVersionFinalizeDocument = /*#__PURE__*/ gql`
    mutation BlueprintVersionFinalize($id: String!, $versionId: String!) {
  blueprintVersionFinalize(id: $id, versionId: $versionId) {
    status
    message
    blueprint {
      ...BlueprintFields
    }
  }
}
    ${BlueprintFieldsFragmentDoc}`;
export type BlueprintVersionFinalizeMutationFn = Apollo.MutationFunction<BlueprintVersionFinalizeMutationData, BlueprintVersionFinalizeMutationVariables>;

/**
 * __useBlueprintVersionFinalizeMutation__
 *
 * To run a mutation, you first call `useBlueprintVersionFinalizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlueprintVersionFinalizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blueprintVersionFinalizeMutation, { data, loading, error }] = useBlueprintVersionFinalizeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useBlueprintVersionFinalizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlueprintVersionFinalizeMutationData, BlueprintVersionFinalizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlueprintVersionFinalizeMutationData, BlueprintVersionFinalizeMutationVariables>(BlueprintVersionFinalizeDocument, options);
      }
export type BlueprintVersionFinalizeMutationHookResult = ReturnType<typeof useBlueprintVersionFinalizeMutation>;
export type BlueprintVersionFinalizeMutationResult = Apollo.MutationResult<BlueprintVersionFinalizeMutationData>;
export type BlueprintVersionFinalizeMutationOptions = Apollo.BaseMutationOptions<BlueprintVersionFinalizeMutationData, BlueprintVersionFinalizeMutationVariables>;
export const BlueprintUpdatesDocument = /*#__PURE__*/ gql`
    query BlueprintUpdates($ids: [String!]!) {
  blueprintUpdates(ids: $ids) {
    blueprintId
    available
    versionId
    version
  }
}
    `;

/**
 * __useBlueprintUpdatesQuery__
 *
 * To run a query within a React component, call `useBlueprintUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintUpdatesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBlueprintUpdatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BlueprintUpdatesQueryData, BlueprintUpdatesQueryVariables> & ({ variables: BlueprintUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BlueprintUpdatesQueryData, BlueprintUpdatesQueryVariables>(BlueprintUpdatesDocument, options);
      }
export function useBlueprintUpdatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BlueprintUpdatesQueryData, BlueprintUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BlueprintUpdatesQueryData, BlueprintUpdatesQueryVariables>(BlueprintUpdatesDocument, options);
        }
export function useBlueprintUpdatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BlueprintUpdatesQueryData, BlueprintUpdatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BlueprintUpdatesQueryData, BlueprintUpdatesQueryVariables>(BlueprintUpdatesDocument, options);
        }
export type BlueprintUpdatesQueryHookResult = ReturnType<typeof useBlueprintUpdatesQuery>;
export type BlueprintUpdatesLazyQueryHookResult = ReturnType<typeof useBlueprintUpdatesLazyQuery>;
export type BlueprintUpdatesSuspenseQueryHookResult = ReturnType<typeof useBlueprintUpdatesSuspenseQuery>;
export type BlueprintUpdatesQueryResult = Apollo.QueryResult<BlueprintUpdatesQueryData, BlueprintUpdatesQueryVariables>;
export const BoardsDocument = /*#__PURE__*/ gql`
    query Boards {
  boards {
    _id
    name
    members {
      _id
      firstName
      lastName
      email
    }
    columns {
      _id
      cards {
        _id
      }
    }
  }
}
    `;

/**
 * __useBoardsQuery__
 *
 * To run a query within a React component, call `useBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBoardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BoardsQueryData, BoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BoardsQueryData, BoardsQueryVariables>(BoardsDocument, options);
      }
export function useBoardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BoardsQueryData, BoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BoardsQueryData, BoardsQueryVariables>(BoardsDocument, options);
        }
export function useBoardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BoardsQueryData, BoardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BoardsQueryData, BoardsQueryVariables>(BoardsDocument, options);
        }
export type BoardsQueryHookResult = ReturnType<typeof useBoardsQuery>;
export type BoardsLazyQueryHookResult = ReturnType<typeof useBoardsLazyQuery>;
export type BoardsSuspenseQueryHookResult = ReturnType<typeof useBoardsSuspenseQuery>;
export type BoardsQueryResult = Apollo.QueryResult<BoardsQueryData, BoardsQueryVariables>;
export const BoardCreateDocument = /*#__PURE__*/ gql`
    mutation BoardCreate($input: BoardCreateInput!) {
  boardCreate(input: $input) {
    _id
    name
    members {
      _id
      firstName
      lastName
      email
    }
    columns {
      _id
      cards {
        _id
      }
    }
  }
}
    `;
export type BoardCreateMutationFn = Apollo.MutationFunction<BoardCreateMutationData, BoardCreateMutationVariables>;

/**
 * __useBoardCreateMutation__
 *
 * To run a mutation, you first call `useBoardCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardCreateMutation, { data, loading, error }] = useBoardCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardCreateMutationData, BoardCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardCreateMutationData, BoardCreateMutationVariables>(BoardCreateDocument, options);
      }
export type BoardCreateMutationHookResult = ReturnType<typeof useBoardCreateMutation>;
export type BoardCreateMutationResult = Apollo.MutationResult<BoardCreateMutationData>;
export type BoardCreateMutationOptions = Apollo.BaseMutationOptions<BoardCreateMutationData, BoardCreateMutationVariables>;
export const BoardDocument = /*#__PURE__*/ gql`
    query Board($id: ID!) {
  board(id: $id) {
    ...BoardCore
  }
}
    ${BoardCoreFragmentDoc}
${BoardColumnCoreFragmentDoc}
${BoardCardCoreFragmentDoc}`;

/**
 * __useBoardQuery__
 *
 * To run a query within a React component, call `useBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBoardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BoardQueryData, BoardQueryVariables> & ({ variables: BoardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BoardQueryData, BoardQueryVariables>(BoardDocument, options);
      }
export function useBoardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BoardQueryData, BoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BoardQueryData, BoardQueryVariables>(BoardDocument, options);
        }
export function useBoardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BoardQueryData, BoardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BoardQueryData, BoardQueryVariables>(BoardDocument, options);
        }
export type BoardQueryHookResult = ReturnType<typeof useBoardQuery>;
export type BoardLazyQueryHookResult = ReturnType<typeof useBoardLazyQuery>;
export type BoardSuspenseQueryHookResult = ReturnType<typeof useBoardSuspenseQuery>;
export type BoardQueryResult = Apollo.QueryResult<BoardQueryData, BoardQueryVariables>;
export const BoardUpdateDocument = /*#__PURE__*/ gql`
    mutation BoardUpdate($input: BoardUpdateInput!) {
  boardUpdate(input: $input) {
    ...BoardCore
  }
}
    ${BoardCoreFragmentDoc}
${BoardColumnCoreFragmentDoc}
${BoardCardCoreFragmentDoc}`;
export type BoardUpdateMutationFn = Apollo.MutationFunction<BoardUpdateMutationData, BoardUpdateMutationVariables>;

/**
 * __useBoardUpdateMutation__
 *
 * To run a mutation, you first call `useBoardUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardUpdateMutation, { data, loading, error }] = useBoardUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardUpdateMutationData, BoardUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardUpdateMutationData, BoardUpdateMutationVariables>(BoardUpdateDocument, options);
      }
export type BoardUpdateMutationHookResult = ReturnType<typeof useBoardUpdateMutation>;
export type BoardUpdateMutationResult = Apollo.MutationResult<BoardUpdateMutationData>;
export type BoardUpdateMutationOptions = Apollo.BaseMutationOptions<BoardUpdateMutationData, BoardUpdateMutationVariables>;
export const BoardColumnCreateDocument = /*#__PURE__*/ gql`
    mutation BoardColumnCreate($input: BoardColumnCreateInput!) {
  boardColumnCreate(input: $input) {
    ...BoardColumnCore
  }
}
    ${BoardColumnCoreFragmentDoc}
${BoardCardCoreFragmentDoc}`;
export type BoardColumnCreateMutationFn = Apollo.MutationFunction<BoardColumnCreateMutationData, BoardColumnCreateMutationVariables>;

/**
 * __useBoardColumnCreateMutation__
 *
 * To run a mutation, you first call `useBoardColumnCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardColumnCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardColumnCreateMutation, { data, loading, error }] = useBoardColumnCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardColumnCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardColumnCreateMutationData, BoardColumnCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardColumnCreateMutationData, BoardColumnCreateMutationVariables>(BoardColumnCreateDocument, options);
      }
export type BoardColumnCreateMutationHookResult = ReturnType<typeof useBoardColumnCreateMutation>;
export type BoardColumnCreateMutationResult = Apollo.MutationResult<BoardColumnCreateMutationData>;
export type BoardColumnCreateMutationOptions = Apollo.BaseMutationOptions<BoardColumnCreateMutationData, BoardColumnCreateMutationVariables>;
export const BoardColumnUpdateDocument = /*#__PURE__*/ gql`
    mutation BoardColumnUpdate($input: BoardColumnUpdateInput!) {
  boardColumnUpdate(input: $input) {
    ...BoardColumnCore
  }
}
    ${BoardColumnCoreFragmentDoc}
${BoardCardCoreFragmentDoc}`;
export type BoardColumnUpdateMutationFn = Apollo.MutationFunction<BoardColumnUpdateMutationData, BoardColumnUpdateMutationVariables>;

/**
 * __useBoardColumnUpdateMutation__
 *
 * To run a mutation, you first call `useBoardColumnUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardColumnUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardColumnUpdateMutation, { data, loading, error }] = useBoardColumnUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardColumnUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardColumnUpdateMutationData, BoardColumnUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardColumnUpdateMutationData, BoardColumnUpdateMutationVariables>(BoardColumnUpdateDocument, options);
      }
export type BoardColumnUpdateMutationHookResult = ReturnType<typeof useBoardColumnUpdateMutation>;
export type BoardColumnUpdateMutationResult = Apollo.MutationResult<BoardColumnUpdateMutationData>;
export type BoardColumnUpdateMutationOptions = Apollo.BaseMutationOptions<BoardColumnUpdateMutationData, BoardColumnUpdateMutationVariables>;
export const BoardColumnDeleteDocument = /*#__PURE__*/ gql`
    mutation BoardColumnDelete($input: BoardColumnDeleteInput!) {
  boardColumnDelete(input: $input)
}
    `;
export type BoardColumnDeleteMutationFn = Apollo.MutationFunction<BoardColumnDeleteMutationData, BoardColumnDeleteMutationVariables>;

/**
 * __useBoardColumnDeleteMutation__
 *
 * To run a mutation, you first call `useBoardColumnDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardColumnDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardColumnDeleteMutation, { data, loading, error }] = useBoardColumnDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardColumnDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardColumnDeleteMutationData, BoardColumnDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardColumnDeleteMutationData, BoardColumnDeleteMutationVariables>(BoardColumnDeleteDocument, options);
      }
export type BoardColumnDeleteMutationHookResult = ReturnType<typeof useBoardColumnDeleteMutation>;
export type BoardColumnDeleteMutationResult = Apollo.MutationResult<BoardColumnDeleteMutationData>;
export type BoardColumnDeleteMutationOptions = Apollo.BaseMutationOptions<BoardColumnDeleteMutationData, BoardColumnDeleteMutationVariables>;
export const BoardColumnMoveDocument = /*#__PURE__*/ gql`
    mutation BoardColumnMove($input: BoardColumnMoveInput!) {
  boardColumnMove(input: $input) {
    ...BoardColumnCore
  }
}
    ${BoardColumnCoreFragmentDoc}
${BoardCardCoreFragmentDoc}`;
export type BoardColumnMoveMutationFn = Apollo.MutationFunction<BoardColumnMoveMutationData, BoardColumnMoveMutationVariables>;

/**
 * __useBoardColumnMoveMutation__
 *
 * To run a mutation, you first call `useBoardColumnMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardColumnMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardColumnMoveMutation, { data, loading, error }] = useBoardColumnMoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardColumnMoveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardColumnMoveMutationData, BoardColumnMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardColumnMoveMutationData, BoardColumnMoveMutationVariables>(BoardColumnMoveDocument, options);
      }
export type BoardColumnMoveMutationHookResult = ReturnType<typeof useBoardColumnMoveMutation>;
export type BoardColumnMoveMutationResult = Apollo.MutationResult<BoardColumnMoveMutationData>;
export type BoardColumnMoveMutationOptions = Apollo.BaseMutationOptions<BoardColumnMoveMutationData, BoardColumnMoveMutationVariables>;
export const BoardCardCreateDocument = /*#__PURE__*/ gql`
    mutation BoardCardCreate($input: BoardCardCreateInput!) {
  boardCardCreate(input: $input) {
    ...BoardCardCore
  }
}
    ${BoardCardCoreFragmentDoc}`;
export type BoardCardCreateMutationFn = Apollo.MutationFunction<BoardCardCreateMutationData, BoardCardCreateMutationVariables>;

/**
 * __useBoardCardCreateMutation__
 *
 * To run a mutation, you first call `useBoardCardCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardCardCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardCardCreateMutation, { data, loading, error }] = useBoardCardCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardCardCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardCardCreateMutationData, BoardCardCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardCardCreateMutationData, BoardCardCreateMutationVariables>(BoardCardCreateDocument, options);
      }
export type BoardCardCreateMutationHookResult = ReturnType<typeof useBoardCardCreateMutation>;
export type BoardCardCreateMutationResult = Apollo.MutationResult<BoardCardCreateMutationData>;
export type BoardCardCreateMutationOptions = Apollo.BaseMutationOptions<BoardCardCreateMutationData, BoardCardCreateMutationVariables>;
export const BoardCardDeleteDocument = /*#__PURE__*/ gql`
    mutation BoardCardDelete($input: BoardCardDeleteInput!) {
  boardCardDelete(input: $input)
}
    `;
export type BoardCardDeleteMutationFn = Apollo.MutationFunction<BoardCardDeleteMutationData, BoardCardDeleteMutationVariables>;

/**
 * __useBoardCardDeleteMutation__
 *
 * To run a mutation, you first call `useBoardCardDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardCardDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardCardDeleteMutation, { data, loading, error }] = useBoardCardDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardCardDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardCardDeleteMutationData, BoardCardDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardCardDeleteMutationData, BoardCardDeleteMutationVariables>(BoardCardDeleteDocument, options);
      }
export type BoardCardDeleteMutationHookResult = ReturnType<typeof useBoardCardDeleteMutation>;
export type BoardCardDeleteMutationResult = Apollo.MutationResult<BoardCardDeleteMutationData>;
export type BoardCardDeleteMutationOptions = Apollo.BaseMutationOptions<BoardCardDeleteMutationData, BoardCardDeleteMutationVariables>;
export const BoardCardMoveDocument = /*#__PURE__*/ gql`
    mutation BoardCardMove($input: BoardCardMoveInput!) {
  boardCardMove(input: $input) {
    ...BoardCardCore
  }
}
    ${BoardCardCoreFragmentDoc}`;
export type BoardCardMoveMutationFn = Apollo.MutationFunction<BoardCardMoveMutationData, BoardCardMoveMutationVariables>;

/**
 * __useBoardCardMoveMutation__
 *
 * To run a mutation, you first call `useBoardCardMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardCardMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardCardMoveMutation, { data, loading, error }] = useBoardCardMoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardCardMoveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardCardMoveMutationData, BoardCardMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardCardMoveMutationData, BoardCardMoveMutationVariables>(BoardCardMoveDocument, options);
      }
export type BoardCardMoveMutationHookResult = ReturnType<typeof useBoardCardMoveMutation>;
export type BoardCardMoveMutationResult = Apollo.MutationResult<BoardCardMoveMutationData>;
export type BoardCardMoveMutationOptions = Apollo.BaseMutationOptions<BoardCardMoveMutationData, BoardCardMoveMutationVariables>;
export const BoardMemberInviteDocument = /*#__PURE__*/ gql`
    mutation BoardMemberInvite($input: BoardMemberInviteInput!) {
  boardMemberInvite(input: $input) {
    ...BoardCore
  }
}
    ${BoardCoreFragmentDoc}
${BoardColumnCoreFragmentDoc}
${BoardCardCoreFragmentDoc}`;
export type BoardMemberInviteMutationFn = Apollo.MutationFunction<BoardMemberInviteMutationData, BoardMemberInviteMutationVariables>;

/**
 * __useBoardMemberInviteMutation__
 *
 * To run a mutation, you first call `useBoardMemberInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardMemberInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardMemberInviteMutation, { data, loading, error }] = useBoardMemberInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardMemberInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardMemberInviteMutationData, BoardMemberInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardMemberInviteMutationData, BoardMemberInviteMutationVariables>(BoardMemberInviteDocument, options);
      }
export type BoardMemberInviteMutationHookResult = ReturnType<typeof useBoardMemberInviteMutation>;
export type BoardMemberInviteMutationResult = Apollo.MutationResult<BoardMemberInviteMutationData>;
export type BoardMemberInviteMutationOptions = Apollo.BaseMutationOptions<BoardMemberInviteMutationData, BoardMemberInviteMutationVariables>;
export const BoardMemberRemoveDocument = /*#__PURE__*/ gql`
    mutation BoardMemberRemove($input: BoardMemberRemoveInput!) {
  boardMemberRemove(input: $input) {
    ...BoardCore
  }
}
    ${BoardCoreFragmentDoc}
${BoardColumnCoreFragmentDoc}
${BoardCardCoreFragmentDoc}`;
export type BoardMemberRemoveMutationFn = Apollo.MutationFunction<BoardMemberRemoveMutationData, BoardMemberRemoveMutationVariables>;

/**
 * __useBoardMemberRemoveMutation__
 *
 * To run a mutation, you first call `useBoardMemberRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardMemberRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardMemberRemoveMutation, { data, loading, error }] = useBoardMemberRemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardMemberRemoveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardMemberRemoveMutationData, BoardMemberRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardMemberRemoveMutationData, BoardMemberRemoveMutationVariables>(BoardMemberRemoveDocument, options);
      }
export type BoardMemberRemoveMutationHookResult = ReturnType<typeof useBoardMemberRemoveMutation>;
export type BoardMemberRemoveMutationResult = Apollo.MutationResult<BoardMemberRemoveMutationData>;
export type BoardMemberRemoveMutationOptions = Apollo.BaseMutationOptions<BoardMemberRemoveMutationData, BoardMemberRemoveMutationVariables>;
export const BoardDeleteDocument = /*#__PURE__*/ gql`
    mutation BoardDelete($input: BoardDeleteInput!) {
  boardDelete(input: $input)
}
    `;
export type BoardDeleteMutationFn = Apollo.MutationFunction<BoardDeleteMutationData, BoardDeleteMutationVariables>;

/**
 * __useBoardDeleteMutation__
 *
 * To run a mutation, you first call `useBoardDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoardDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boardDeleteMutation, { data, loading, error }] = useBoardDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoardDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BoardDeleteMutationData, BoardDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BoardDeleteMutationData, BoardDeleteMutationVariables>(BoardDeleteDocument, options);
      }
export type BoardDeleteMutationHookResult = ReturnType<typeof useBoardDeleteMutation>;
export type BoardDeleteMutationResult = Apollo.MutationResult<BoardDeleteMutationData>;
export type BoardDeleteMutationOptions = Apollo.BaseMutationOptions<BoardDeleteMutationData, BoardDeleteMutationVariables>;
export const GetCommentsDocument = /*#__PURE__*/ gql`
    query getComments($target: CommentTargetInput!) {
  comments(target: $target) {
    _id
    targetId
    parentId
    versionNumber
    fileId
    body
    authorId
    createdAt
    editedAt
    resolvedAt
    resolvedBy
    anchor {
      kind
      atMs
    }
    author {
      _id
      firstName
      lastName
      artistName
      image
    }
    replies {
      _id
      targetId
      parentId
      body
      authorId
      createdAt
      editedAt
      resolvedAt
      resolvedBy
      anchor {
        kind
        atMs
      }
      author {
        _id
        firstName
        lastName
        artistName
        image
      }
    }
  }
}
    `;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCommentsQueryData, GetCommentsQueryVariables> & ({ variables: GetCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommentsQueryData, GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCommentsQueryData, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommentsQueryData, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export function useGetCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCommentsQueryData, GetCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCommentsQueryData, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsSuspenseQueryHookResult = ReturnType<typeof useGetCommentsSuspenseQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<GetCommentsQueryData, GetCommentsQueryVariables>;
export const CommentCreateDocument = /*#__PURE__*/ gql`
    mutation commentCreate($input: CommentCreateInput!) {
  commentCreate(input: $input) {
    _id
  }
}
    `;
export type CommentCreateMutationFn = Apollo.MutationFunction<CommentCreateMutationData, CommentCreateMutationVariables>;

/**
 * __useCommentCreateMutation__
 *
 * To run a mutation, you first call `useCommentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentCreateMutation, { data, loading, error }] = useCommentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommentCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CommentCreateMutationData, CommentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CommentCreateMutationData, CommentCreateMutationVariables>(CommentCreateDocument, options);
      }
export type CommentCreateMutationHookResult = ReturnType<typeof useCommentCreateMutation>;
export type CommentCreateMutationResult = Apollo.MutationResult<CommentCreateMutationData>;
export type CommentCreateMutationOptions = Apollo.BaseMutationOptions<CommentCreateMutationData, CommentCreateMutationVariables>;
export const CommentUpdateDocument = /*#__PURE__*/ gql`
    mutation commentUpdate($input: CommentUpdateInput!) {
  commentUpdate(input: $input) {
    _id
  }
}
    `;
export type CommentUpdateMutationFn = Apollo.MutationFunction<CommentUpdateMutationData, CommentUpdateMutationVariables>;

/**
 * __useCommentUpdateMutation__
 *
 * To run a mutation, you first call `useCommentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentUpdateMutation, { data, loading, error }] = useCommentUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommentUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CommentUpdateMutationData, CommentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CommentUpdateMutationData, CommentUpdateMutationVariables>(CommentUpdateDocument, options);
      }
export type CommentUpdateMutationHookResult = ReturnType<typeof useCommentUpdateMutation>;
export type CommentUpdateMutationResult = Apollo.MutationResult<CommentUpdateMutationData>;
export type CommentUpdateMutationOptions = Apollo.BaseMutationOptions<CommentUpdateMutationData, CommentUpdateMutationVariables>;
export const CommentDeleteDocument = /*#__PURE__*/ gql`
    mutation commentDelete($input: CommentDeleteInput!) {
  commentDelete(input: $input)
}
    `;
export type CommentDeleteMutationFn = Apollo.MutationFunction<CommentDeleteMutationData, CommentDeleteMutationVariables>;

/**
 * __useCommentDeleteMutation__
 *
 * To run a mutation, you first call `useCommentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentDeleteMutation, { data, loading, error }] = useCommentDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommentDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CommentDeleteMutationData, CommentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CommentDeleteMutationData, CommentDeleteMutationVariables>(CommentDeleteDocument, options);
      }
export type CommentDeleteMutationHookResult = ReturnType<typeof useCommentDeleteMutation>;
export type CommentDeleteMutationResult = Apollo.MutationResult<CommentDeleteMutationData>;
export type CommentDeleteMutationOptions = Apollo.BaseMutationOptions<CommentDeleteMutationData, CommentDeleteMutationVariables>;
export const CommentResolveDocument = /*#__PURE__*/ gql`
    mutation commentResolve($input: CommentResolveInput!) {
  commentResolve(input: $input) {
    _id
  }
}
    `;
export type CommentResolveMutationFn = Apollo.MutationFunction<CommentResolveMutationData, CommentResolveMutationVariables>;

/**
 * __useCommentResolveMutation__
 *
 * To run a mutation, you first call `useCommentResolveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentResolveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentResolveMutation, { data, loading, error }] = useCommentResolveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommentResolveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CommentResolveMutationData, CommentResolveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CommentResolveMutationData, CommentResolveMutationVariables>(CommentResolveDocument, options);
      }
export type CommentResolveMutationHookResult = ReturnType<typeof useCommentResolveMutation>;
export type CommentResolveMutationResult = Apollo.MutationResult<CommentResolveMutationData>;
export type CommentResolveMutationOptions = Apollo.BaseMutationOptions<CommentResolveMutationData, CommentResolveMutationVariables>;
export const CommentReopenDocument = /*#__PURE__*/ gql`
    mutation commentReopen($input: CommentReopenInput!) {
  commentReopen(input: $input) {
    _id
  }
}
    `;
export type CommentReopenMutationFn = Apollo.MutationFunction<CommentReopenMutationData, CommentReopenMutationVariables>;

/**
 * __useCommentReopenMutation__
 *
 * To run a mutation, you first call `useCommentReopenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentReopenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentReopenMutation, { data, loading, error }] = useCommentReopenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommentReopenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CommentReopenMutationData, CommentReopenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CommentReopenMutationData, CommentReopenMutationVariables>(CommentReopenDocument, options);
      }
export type CommentReopenMutationHookResult = ReturnType<typeof useCommentReopenMutation>;
export type CommentReopenMutationResult = Apollo.MutationResult<CommentReopenMutationData>;
export type CommentReopenMutationOptions = Apollo.BaseMutationOptions<CommentReopenMutationData, CommentReopenMutationVariables>;
export const GetMyProjectActivitySummaryDocument = /*#__PURE__*/ gql`
    query getMyProjectActivitySummary($from: DateTime!, $to: DateTime!) {
  myProjectActivitySummary(from: $from, to: $to) {
    totalContributions
    activeDays
    currentStreak
    longestStreak
    availableYears
    trackingStartedAt
    days {
      date
      count
    }
  }
}
    `;

/**
 * __useGetMyProjectActivitySummaryQuery__
 *
 * To run a query within a React component, call `useGetMyProjectActivitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProjectActivitySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProjectActivitySummaryQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetMyProjectActivitySummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMyProjectActivitySummaryQueryData, GetMyProjectActivitySummaryQueryVariables> & ({ variables: GetMyProjectActivitySummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyProjectActivitySummaryQueryData, GetMyProjectActivitySummaryQueryVariables>(GetMyProjectActivitySummaryDocument, options);
      }
export function useGetMyProjectActivitySummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyProjectActivitySummaryQueryData, GetMyProjectActivitySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyProjectActivitySummaryQueryData, GetMyProjectActivitySummaryQueryVariables>(GetMyProjectActivitySummaryDocument, options);
        }
export function useGetMyProjectActivitySummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyProjectActivitySummaryQueryData, GetMyProjectActivitySummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyProjectActivitySummaryQueryData, GetMyProjectActivitySummaryQueryVariables>(GetMyProjectActivitySummaryDocument, options);
        }
export type GetMyProjectActivitySummaryQueryHookResult = ReturnType<typeof useGetMyProjectActivitySummaryQuery>;
export type GetMyProjectActivitySummaryLazyQueryHookResult = ReturnType<typeof useGetMyProjectActivitySummaryLazyQuery>;
export type GetMyProjectActivitySummarySuspenseQueryHookResult = ReturnType<typeof useGetMyProjectActivitySummarySuspenseQuery>;
export type GetMyProjectActivitySummaryQueryResult = Apollo.QueryResult<GetMyProjectActivitySummaryQueryData, GetMyProjectActivitySummaryQueryVariables>;
export const GetMyProjectActivityFeedDocument = /*#__PURE__*/ gql`
    query getMyProjectActivityFeed($from: DateTime!, $to: DateTime!, $pagination: PaginationInput!, $sort: ProjectActivitySortInput) {
  myProjectActivityFeed(
    from: $from
    to: $to
    pagination: $pagination
    sort: $sort
  ) {
    items {
      id
      occurredAt
      project {
        id
        name
      }
      version {
        id
        number
        commitMessage
        createdFileCount
        updatedFileCount
        deletedFileCount
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
    }
  }
}
    `;

/**
 * __useGetMyProjectActivityFeedQuery__
 *
 * To run a query within a React component, call `useGetMyProjectActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProjectActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProjectActivityFeedQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMyProjectActivityFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMyProjectActivityFeedQueryData, GetMyProjectActivityFeedQueryVariables> & ({ variables: GetMyProjectActivityFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyProjectActivityFeedQueryData, GetMyProjectActivityFeedQueryVariables>(GetMyProjectActivityFeedDocument, options);
      }
export function useGetMyProjectActivityFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyProjectActivityFeedQueryData, GetMyProjectActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyProjectActivityFeedQueryData, GetMyProjectActivityFeedQueryVariables>(GetMyProjectActivityFeedDocument, options);
        }
export function useGetMyProjectActivityFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyProjectActivityFeedQueryData, GetMyProjectActivityFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyProjectActivityFeedQueryData, GetMyProjectActivityFeedQueryVariables>(GetMyProjectActivityFeedDocument, options);
        }
export type GetMyProjectActivityFeedQueryHookResult = ReturnType<typeof useGetMyProjectActivityFeedQuery>;
export type GetMyProjectActivityFeedLazyQueryHookResult = ReturnType<typeof useGetMyProjectActivityFeedLazyQuery>;
export type GetMyProjectActivityFeedSuspenseQueryHookResult = ReturnType<typeof useGetMyProjectActivityFeedSuspenseQuery>;
export type GetMyProjectActivityFeedQueryResult = Apollo.QueryResult<GetMyProjectActivityFeedQueryData, GetMyProjectActivityFeedQueryVariables>;
export const GetProjectsDocument = /*#__PURE__*/ gql`
    query getProjects {
  projects {
    _id
    name
    versionCount
    ownerUser {
      _id
      firstName
      lastName
    }
    description
    updatedAt
    members {
      artistName
    }
    versionHistory {
      _id
      version
    }
    previewFile {
      _id
      waveForm {
        duration
        peakCount
        peaks
      }
    }
  }
}
    `;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectsQueryData, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectsQueryData, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectsQueryData, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectsQueryData, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export function useGetProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectsQueryData, GetProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectsQueryData, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsSuspenseQueryHookResult = ReturnType<typeof useGetProjectsSuspenseQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQueryData, GetProjectsQueryVariables>;
export const GetProjectPreviewDocument = /*#__PURE__*/ gql`
    query getProjectPreview($projectId: String!, $version: Float!) {
  projectVersion(projectId: $projectId, version: $version) {
    _id
    previewFile {
      _id
      fileName
      waveForm {
        duration
        peakCount
        peaks
      }
    }
  }
}
    `;

/**
 * __useGetProjectPreviewQuery__
 *
 * To run a query within a React component, call `useGetProjectPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPreviewQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetProjectPreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectPreviewQueryData, GetProjectPreviewQueryVariables> & ({ variables: GetProjectPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectPreviewQueryData, GetProjectPreviewQueryVariables>(GetProjectPreviewDocument, options);
      }
export function useGetProjectPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectPreviewQueryData, GetProjectPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectPreviewQueryData, GetProjectPreviewQueryVariables>(GetProjectPreviewDocument, options);
        }
export function useGetProjectPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectPreviewQueryData, GetProjectPreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectPreviewQueryData, GetProjectPreviewQueryVariables>(GetProjectPreviewDocument, options);
        }
export type GetProjectPreviewQueryHookResult = ReturnType<typeof useGetProjectPreviewQuery>;
export type GetProjectPreviewLazyQueryHookResult = ReturnType<typeof useGetProjectPreviewLazyQuery>;
export type GetProjectPreviewSuspenseQueryHookResult = ReturnType<typeof useGetProjectPreviewSuspenseQuery>;
export type GetProjectPreviewQueryResult = Apollo.QueryResult<GetProjectPreviewQueryData, GetProjectPreviewQueryVariables>;
export const GetProjectLibraryFilesDocument = /*#__PURE__*/ gql`
    query getProjectLibraryFiles($projectId: String!, $version: Float!) {
  projectVersion(projectId: $projectId, version: $version) {
    _id
    files {
      _id
      fileName
      quickHash
      fullHash
      uploadedAt
      size
      contentType
      s3Key
    }
  }
}
    `;

/**
 * __useGetProjectLibraryFilesQuery__
 *
 * To run a query within a React component, call `useGetProjectLibraryFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectLibraryFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectLibraryFilesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetProjectLibraryFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectLibraryFilesQueryData, GetProjectLibraryFilesQueryVariables> & ({ variables: GetProjectLibraryFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectLibraryFilesQueryData, GetProjectLibraryFilesQueryVariables>(GetProjectLibraryFilesDocument, options);
      }
export function useGetProjectLibraryFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectLibraryFilesQueryData, GetProjectLibraryFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectLibraryFilesQueryData, GetProjectLibraryFilesQueryVariables>(GetProjectLibraryFilesDocument, options);
        }
export function useGetProjectLibraryFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectLibraryFilesQueryData, GetProjectLibraryFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectLibraryFilesQueryData, GetProjectLibraryFilesQueryVariables>(GetProjectLibraryFilesDocument, options);
        }
export type GetProjectLibraryFilesQueryHookResult = ReturnType<typeof useGetProjectLibraryFilesQuery>;
export type GetProjectLibraryFilesLazyQueryHookResult = ReturnType<typeof useGetProjectLibraryFilesLazyQuery>;
export type GetProjectLibraryFilesSuspenseQueryHookResult = ReturnType<typeof useGetProjectLibraryFilesSuspenseQuery>;
export type GetProjectLibraryFilesQueryResult = Apollo.QueryResult<GetProjectLibraryFilesQueryData, GetProjectLibraryFilesQueryVariables>;
export const GetProjectDocument = /*#__PURE__*/ gql`
    query getProject($projectId: String!) {
  project(projectId: $projectId) {
    _id
    name
    description
    tags
    owner
    createdAt
    updatedAt
    versionHistory {
      _id
      version
      commitMessage
      deletedFiles
      createdFiles
      updatedFiles
      createdAt
      plugins {
        name
        vendor
        pluginType
        vst2Id
        confidence
        detectionMethod
        detectionCount
      }
    }
    members {
      _id
      userId
      userEmail
      artistName
      role
      joinedAt
    }
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectQueryData, GetProjectQueryVariables> & ({ variables: GetProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectQueryData, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectQueryData, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectQueryData, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export function useGetProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectQueryData, GetProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectQueryData, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQueryData, GetProjectQueryVariables>;
export const GetProjectVersionDocument = /*#__PURE__*/ gql`
    query getProjectVersion($projectId: String!, $version: Float!) {
  projectVersion(projectId: $projectId, version: $version) {
    _id
    name
    description
    tags
    owner
    createdAt
    updatedAt
    files {
      _id
      fileName
      contentType
      size
      uploadedAt
      s3Key
      quickHash
      fullHash
      replacesFileId
      waveForm {
        duration
        peakCount
        peaks
      }
    }
    versionHistory {
      _id
      version
      commitMessage
      deletedFiles
      createdFiles
      updatedFiles
      createdAt
      plugins {
        name
        vendor
        pluginType
        vst2Id
        confidence
        detectionMethod
        detectionCount
      }
    }
    members {
      _id
      userId
      userEmail
      role
      joinedAt
    }
  }
}
    `;

/**
 * __useGetProjectVersionQuery__
 *
 * To run a query within a React component, call `useGetProjectVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectVersionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetProjectVersionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectVersionQueryData, GetProjectVersionQueryVariables> & ({ variables: GetProjectVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectVersionQueryData, GetProjectVersionQueryVariables>(GetProjectVersionDocument, options);
      }
export function useGetProjectVersionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectVersionQueryData, GetProjectVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectVersionQueryData, GetProjectVersionQueryVariables>(GetProjectVersionDocument, options);
        }
export function useGetProjectVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectVersionQueryData, GetProjectVersionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectVersionQueryData, GetProjectVersionQueryVariables>(GetProjectVersionDocument, options);
        }
export type GetProjectVersionQueryHookResult = ReturnType<typeof useGetProjectVersionQuery>;
export type GetProjectVersionLazyQueryHookResult = ReturnType<typeof useGetProjectVersionLazyQuery>;
export type GetProjectVersionSuspenseQueryHookResult = ReturnType<typeof useGetProjectVersionSuspenseQuery>;
export type GetProjectVersionQueryResult = Apollo.QueryResult<GetProjectVersionQueryData, GetProjectVersionQueryVariables>;
export const GetProjectInvitesDocument = /*#__PURE__*/ gql`
    query getProjectInvites($projectId: String!) {
  projectInvitesSent(projectId: $projectId) {
    _id
    email
    status
    role
    createdAt
    expiresAt
  }
}
    `;

/**
 * __useGetProjectInvitesQuery__
 *
 * To run a query within a React component, call `useGetProjectInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectInvitesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectInvitesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectInvitesQueryData, GetProjectInvitesQueryVariables> & ({ variables: GetProjectInvitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectInvitesQueryData, GetProjectInvitesQueryVariables>(GetProjectInvitesDocument, options);
      }
export function useGetProjectInvitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectInvitesQueryData, GetProjectInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectInvitesQueryData, GetProjectInvitesQueryVariables>(GetProjectInvitesDocument, options);
        }
export function useGetProjectInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectInvitesQueryData, GetProjectInvitesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectInvitesQueryData, GetProjectInvitesQueryVariables>(GetProjectInvitesDocument, options);
        }
export type GetProjectInvitesQueryHookResult = ReturnType<typeof useGetProjectInvitesQuery>;
export type GetProjectInvitesLazyQueryHookResult = ReturnType<typeof useGetProjectInvitesLazyQuery>;
export type GetProjectInvitesSuspenseQueryHookResult = ReturnType<typeof useGetProjectInvitesSuspenseQuery>;
export type GetProjectInvitesQueryResult = Apollo.QueryResult<GetProjectInvitesQueryData, GetProjectInvitesQueryVariables>;
export const GetMyInvitesDocument = /*#__PURE__*/ gql`
    query getMyInvites {
  projectInvites {
    _id
    projectName
    invitedByEmail
    role
    expiresAt
  }
}
    `;

/**
 * __useGetMyInvitesQuery__
 *
 * To run a query within a React component, call `useGetMyInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyInvitesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyInvitesQueryData, GetMyInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyInvitesQueryData, GetMyInvitesQueryVariables>(GetMyInvitesDocument, options);
      }
export function useGetMyInvitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyInvitesQueryData, GetMyInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyInvitesQueryData, GetMyInvitesQueryVariables>(GetMyInvitesDocument, options);
        }
export function useGetMyInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyInvitesQueryData, GetMyInvitesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyInvitesQueryData, GetMyInvitesQueryVariables>(GetMyInvitesDocument, options);
        }
export type GetMyInvitesQueryHookResult = ReturnType<typeof useGetMyInvitesQuery>;
export type GetMyInvitesLazyQueryHookResult = ReturnType<typeof useGetMyInvitesLazyQuery>;
export type GetMyInvitesSuspenseQueryHookResult = ReturnType<typeof useGetMyInvitesSuspenseQuery>;
export type GetMyInvitesQueryResult = Apollo.QueryResult<GetMyInvitesQueryData, GetMyInvitesQueryVariables>;
export const CreateProjectDocument = /*#__PURE__*/ gql`
    mutation createProject($data: ProjectCreateInput!) {
  projectCreate(data: $data) {
    _id
    name
    description
    tags
    createdAt
    versionHistory {
      _id
      version
      commitMessage
      deletedFiles
      createdFiles
      updatedFiles
      createdAt
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutationData, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectMutationData, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectMutationData, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutationData>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutationData, CreateProjectMutationVariables>;
export const UpdateProjectDocument = /*#__PURE__*/ gql`
    mutation updateProject($projectId: String!, $data: ProjectUpdateInput!) {
  projectUpdate(projectId: $projectId, data: $data) {
    _id
    name
    description
    tags
    updatedAt
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutationData, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectMutationData, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectMutationData, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutationData>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutationData, UpdateProjectMutationVariables>;
export const DeleteProjectDocument = /*#__PURE__*/ gql`
    mutation deleteProject($projectId: String!) {
  projectDelete(projectId: $projectId)
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutationData, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectMutationData, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProjectMutationData, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutationData>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutationData, DeleteProjectMutationVariables>;
export const ProjectVersionPushDocument = /*#__PURE__*/ gql`
    mutation projectVersionPush($projectId: String!, $data: ProjectVersionPushInput!) {
  projectVersionPush(projectId: $projectId, data: $data) {
    version {
      _id
    }
    uploadUrls {
      presignedUrl
      uploadRequired
      key
      quickHash
      fullHash
      replacesFileId
    }
  }
}
    `;
export type ProjectVersionPushMutationFn = Apollo.MutationFunction<ProjectVersionPushMutationData, ProjectVersionPushMutationVariables>;

/**
 * __useProjectVersionPushMutation__
 *
 * To run a mutation, you first call `useProjectVersionPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectVersionPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectVersionPushMutation, { data, loading, error }] = useProjectVersionPushMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProjectVersionPushMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectVersionPushMutationData, ProjectVersionPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectVersionPushMutationData, ProjectVersionPushMutationVariables>(ProjectVersionPushDocument, options);
      }
export type ProjectVersionPushMutationHookResult = ReturnType<typeof useProjectVersionPushMutation>;
export type ProjectVersionPushMutationResult = Apollo.MutationResult<ProjectVersionPushMutationData>;
export type ProjectVersionPushMutationOptions = Apollo.BaseMutationOptions<ProjectVersionPushMutationData, ProjectVersionPushMutationVariables>;
export const ProjectVersionRollbackDocument = /*#__PURE__*/ gql`
    mutation projectVersionRollback($projectId: String!, $versionId: String!) {
  projectVersionRollback(projectId: $projectId, versionId: $versionId)
}
    `;
export type ProjectVersionRollbackMutationFn = Apollo.MutationFunction<ProjectVersionRollbackMutationData, ProjectVersionRollbackMutationVariables>;

/**
 * __useProjectVersionRollbackMutation__
 *
 * To run a mutation, you first call `useProjectVersionRollbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectVersionRollbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectVersionRollbackMutation, { data, loading, error }] = useProjectVersionRollbackMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProjectVersionRollbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectVersionRollbackMutationData, ProjectVersionRollbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectVersionRollbackMutationData, ProjectVersionRollbackMutationVariables>(ProjectVersionRollbackDocument, options);
      }
export type ProjectVersionRollbackMutationHookResult = ReturnType<typeof useProjectVersionRollbackMutation>;
export type ProjectVersionRollbackMutationResult = Apollo.MutationResult<ProjectVersionRollbackMutationData>;
export type ProjectVersionRollbackMutationOptions = Apollo.BaseMutationOptions<ProjectVersionRollbackMutationData, ProjectVersionRollbackMutationVariables>;
export const ProjectVersionFinalizeDocument = /*#__PURE__*/ gql`
    mutation projectVersionFinalize($projectId: String!, $versionId: String!) {
  projectVersionFinalize(projectId: $projectId, versionId: $versionId)
}
    `;
export type ProjectVersionFinalizeMutationFn = Apollo.MutationFunction<ProjectVersionFinalizeMutationData, ProjectVersionFinalizeMutationVariables>;

/**
 * __useProjectVersionFinalizeMutation__
 *
 * To run a mutation, you first call `useProjectVersionFinalizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectVersionFinalizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectVersionFinalizeMutation, { data, loading, error }] = useProjectVersionFinalizeMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProjectVersionFinalizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectVersionFinalizeMutationData, ProjectVersionFinalizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectVersionFinalizeMutationData, ProjectVersionFinalizeMutationVariables>(ProjectVersionFinalizeDocument, options);
      }
export type ProjectVersionFinalizeMutationHookResult = ReturnType<typeof useProjectVersionFinalizeMutation>;
export type ProjectVersionFinalizeMutationResult = Apollo.MutationResult<ProjectVersionFinalizeMutationData>;
export type ProjectVersionFinalizeMutationOptions = Apollo.BaseMutationOptions<ProjectVersionFinalizeMutationData, ProjectVersionFinalizeMutationVariables>;
export const InviteToProjectDocument = /*#__PURE__*/ gql`
    mutation inviteToProject($data: ProjectInviteInput!) {
  projectInvite(data: $data) {
    _id
    email
    projectName
    invitedByEmail
    role
    status
    expiresAt
  }
}
    `;
export type InviteToProjectMutationFn = Apollo.MutationFunction<InviteToProjectMutationData, InviteToProjectMutationVariables>;

/**
 * __useInviteToProjectMutation__
 *
 * To run a mutation, you first call `useInviteToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToProjectMutation, { data, loading, error }] = useInviteToProjectMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInviteToProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InviteToProjectMutationData, InviteToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InviteToProjectMutationData, InviteToProjectMutationVariables>(InviteToProjectDocument, options);
      }
export type InviteToProjectMutationHookResult = ReturnType<typeof useInviteToProjectMutation>;
export type InviteToProjectMutationResult = Apollo.MutationResult<InviteToProjectMutationData>;
export type InviteToProjectMutationOptions = Apollo.BaseMutationOptions<InviteToProjectMutationData, InviteToProjectMutationVariables>;
export const RemoveProjectMemberDocument = /*#__PURE__*/ gql`
    mutation removeProjectMember($data: ProjectMemberRemoveInput!) {
  projectMemberRemove(data: $data)
}
    `;
export type RemoveProjectMemberMutationFn = Apollo.MutationFunction<RemoveProjectMemberMutationData, RemoveProjectMemberMutationVariables>;

/**
 * __useRemoveProjectMemberMutation__
 *
 * To run a mutation, you first call `useRemoveProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectMemberMutation, { data, loading, error }] = useRemoveProjectMemberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveProjectMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveProjectMemberMutationData, RemoveProjectMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveProjectMemberMutationData, RemoveProjectMemberMutationVariables>(RemoveProjectMemberDocument, options);
      }
export type RemoveProjectMemberMutationHookResult = ReturnType<typeof useRemoveProjectMemberMutation>;
export type RemoveProjectMemberMutationResult = Apollo.MutationResult<RemoveProjectMemberMutationData>;
export type RemoveProjectMemberMutationOptions = Apollo.BaseMutationOptions<RemoveProjectMemberMutationData, RemoveProjectMemberMutationVariables>;
export const LeaveProjectDocument = /*#__PURE__*/ gql`
    mutation leaveProject($projectId: String!) {
  projectLeave(projectId: $projectId)
}
    `;
export type LeaveProjectMutationFn = Apollo.MutationFunction<LeaveProjectMutationData, LeaveProjectMutationVariables>;

/**
 * __useLeaveProjectMutation__
 *
 * To run a mutation, you first call `useLeaveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveProjectMutation, { data, loading, error }] = useLeaveProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useLeaveProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LeaveProjectMutationData, LeaveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LeaveProjectMutationData, LeaveProjectMutationVariables>(LeaveProjectDocument, options);
      }
export type LeaveProjectMutationHookResult = ReturnType<typeof useLeaveProjectMutation>;
export type LeaveProjectMutationResult = Apollo.MutationResult<LeaveProjectMutationData>;
export type LeaveProjectMutationOptions = Apollo.BaseMutationOptions<LeaveProjectMutationData, LeaveProjectMutationVariables>;
export const RespondToInviteDocument = /*#__PURE__*/ gql`
    mutation respondToInvite($data: ProjectInviteResponseInput!) {
  projectInviteRespond(data: $data)
}
    `;
export type RespondToInviteMutationFn = Apollo.MutationFunction<RespondToInviteMutationData, RespondToInviteMutationVariables>;

/**
 * __useRespondToInviteMutation__
 *
 * To run a mutation, you first call `useRespondToInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToInviteMutation, { data, loading, error }] = useRespondToInviteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRespondToInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RespondToInviteMutationData, RespondToInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RespondToInviteMutationData, RespondToInviteMutationVariables>(RespondToInviteDocument, options);
      }
export type RespondToInviteMutationHookResult = ReturnType<typeof useRespondToInviteMutation>;
export type RespondToInviteMutationResult = Apollo.MutationResult<RespondToInviteMutationData>;
export type RespondToInviteMutationOptions = Apollo.BaseMutationOptions<RespondToInviteMutationData, RespondToInviteMutationVariables>;
export const ProjectInviteCancelDocument = /*#__PURE__*/ gql`
    mutation projectInviteCancel($data: ProjectInviteCancelInput!) {
  projectInviteCancel(data: $data)
}
    `;
export type ProjectInviteCancelMutationFn = Apollo.MutationFunction<ProjectInviteCancelMutationData, ProjectInviteCancelMutationVariables>;

/**
 * __useProjectInviteCancelMutation__
 *
 * To run a mutation, you first call `useProjectInviteCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectInviteCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectInviteCancelMutation, { data, loading, error }] = useProjectInviteCancelMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProjectInviteCancelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectInviteCancelMutationData, ProjectInviteCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectInviteCancelMutationData, ProjectInviteCancelMutationVariables>(ProjectInviteCancelDocument, options);
      }
export type ProjectInviteCancelMutationHookResult = ReturnType<typeof useProjectInviteCancelMutation>;
export type ProjectInviteCancelMutationResult = Apollo.MutationResult<ProjectInviteCancelMutationData>;
export type ProjectInviteCancelMutationOptions = Apollo.BaseMutationOptions<ProjectInviteCancelMutationData, ProjectInviteCancelMutationVariables>;
export const FileUploadDocument = /*#__PURE__*/ gql`
    mutation fileUpload($data: FileUploadInput!) {
  fileUpload(data: $data) {
    key
    presignedUrl
    quickHash
    fullHash
    replacesFileId
  }
}
    `;
export type FileUploadMutationFn = Apollo.MutationFunction<FileUploadMutationData, FileUploadMutationVariables>;

/**
 * __useFileUploadMutation__
 *
 * To run a mutation, you first call `useFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUploadMutation, { data, loading, error }] = useFileUploadMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFileUploadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FileUploadMutationData, FileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FileUploadMutationData, FileUploadMutationVariables>(FileUploadDocument, options);
      }
export type FileUploadMutationHookResult = ReturnType<typeof useFileUploadMutation>;
export type FileUploadMutationResult = Apollo.MutationResult<FileUploadMutationData>;
export type FileUploadMutationOptions = Apollo.BaseMutationOptions<FileUploadMutationData, FileUploadMutationVariables>;
export const FileDownloadDocument = /*#__PURE__*/ gql`
    mutation fileDownload($data: FileDownloadInput!) {
  fileDownload(data: $data) {
    presignedUrl
    fileName
    contentType
  }
}
    `;
export type FileDownloadMutationFn = Apollo.MutationFunction<FileDownloadMutationData, FileDownloadMutationVariables>;

/**
 * __useFileDownloadMutation__
 *
 * To run a mutation, you first call `useFileDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileDownloadMutation, { data, loading, error }] = useFileDownloadMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFileDownloadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FileDownloadMutationData, FileDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FileDownloadMutationData, FileDownloadMutationVariables>(FileDownloadDocument, options);
      }
export type FileDownloadMutationHookResult = ReturnType<typeof useFileDownloadMutation>;
export type FileDownloadMutationResult = Apollo.MutationResult<FileDownloadMutationData>;
export type FileDownloadMutationOptions = Apollo.BaseMutationOptions<FileDownloadMutationData, FileDownloadMutationVariables>;
export const FileDeleteDocument = /*#__PURE__*/ gql`
    mutation fileDelete($data: FileDeleteInput!) {
  fileDelete(data: $data)
}
    `;
export type FileDeleteMutationFn = Apollo.MutationFunction<FileDeleteMutationData, FileDeleteMutationVariables>;

/**
 * __useFileDeleteMutation__
 *
 * To run a mutation, you first call `useFileDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileDeleteMutation, { data, loading, error }] = useFileDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFileDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FileDeleteMutationData, FileDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FileDeleteMutationData, FileDeleteMutationVariables>(FileDeleteDocument, options);
      }
export type FileDeleteMutationHookResult = ReturnType<typeof useFileDeleteMutation>;
export type FileDeleteMutationResult = Apollo.MutationResult<FileDeleteMutationData>;
export type FileDeleteMutationOptions = Apollo.BaseMutationOptions<FileDeleteMutationData, FileDeleteMutationVariables>;
export const GetRenderFolderOptionsDocument = /*#__PURE__*/ gql`
    query getRenderFolderOptions {
  renderFolderOptions
}
    `;

/**
 * __useGetRenderFolderOptionsQuery__
 *
 * To run a query within a React component, call `useGetRenderFolderOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderFolderOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderFolderOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRenderFolderOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRenderFolderOptionsQueryData, GetRenderFolderOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRenderFolderOptionsQueryData, GetRenderFolderOptionsQueryVariables>(GetRenderFolderOptionsDocument, options);
      }
export function useGetRenderFolderOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRenderFolderOptionsQueryData, GetRenderFolderOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRenderFolderOptionsQueryData, GetRenderFolderOptionsQueryVariables>(GetRenderFolderOptionsDocument, options);
        }
export function useGetRenderFolderOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRenderFolderOptionsQueryData, GetRenderFolderOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRenderFolderOptionsQueryData, GetRenderFolderOptionsQueryVariables>(GetRenderFolderOptionsDocument, options);
        }
export type GetRenderFolderOptionsQueryHookResult = ReturnType<typeof useGetRenderFolderOptionsQuery>;
export type GetRenderFolderOptionsLazyQueryHookResult = ReturnType<typeof useGetRenderFolderOptionsLazyQuery>;
export type GetRenderFolderOptionsSuspenseQueryHookResult = ReturnType<typeof useGetRenderFolderOptionsSuspenseQuery>;
export type GetRenderFolderOptionsQueryResult = Apollo.QueryResult<GetRenderFolderOptionsQueryData, GetRenderFolderOptionsQueryVariables>;
export const GetReleaseLatestDocument = /*#__PURE__*/ gql`
    query getReleaseLatest($channel: String) {
  releaseLatest(channel: $channel) {
    channel
    version
    urls {
      mac
      win
      linux
    }
  }
}
    `;

/**
 * __useGetReleaseLatestQuery__
 *
 * To run a query within a React component, call `useGetReleaseLatestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReleaseLatestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReleaseLatestQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useGetReleaseLatestQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReleaseLatestQueryData, GetReleaseLatestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReleaseLatestQueryData, GetReleaseLatestQueryVariables>(GetReleaseLatestDocument, options);
      }
export function useGetReleaseLatestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReleaseLatestQueryData, GetReleaseLatestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReleaseLatestQueryData, GetReleaseLatestQueryVariables>(GetReleaseLatestDocument, options);
        }
export function useGetReleaseLatestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReleaseLatestQueryData, GetReleaseLatestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReleaseLatestQueryData, GetReleaseLatestQueryVariables>(GetReleaseLatestDocument, options);
        }
export type GetReleaseLatestQueryHookResult = ReturnType<typeof useGetReleaseLatestQuery>;
export type GetReleaseLatestLazyQueryHookResult = ReturnType<typeof useGetReleaseLatestLazyQuery>;
export type GetReleaseLatestSuspenseQueryHookResult = ReturnType<typeof useGetReleaseLatestSuspenseQuery>;
export type GetReleaseLatestQueryResult = Apollo.QueryResult<GetReleaseLatestQueryData, GetReleaseLatestQueryVariables>;
export const GetUserProfileDocument = /*#__PURE__*/ gql`
    query getUserProfile {
  user {
    artistName
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserProfileQueryData, GetUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserProfileQueryData, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserProfileQueryData, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserProfileQueryData, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export function useGetUserProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserProfileQueryData, GetUserProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserProfileQueryData, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileSuspenseQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQueryData, GetUserProfileQueryVariables>;
export const GetUserProfileMinimalDocument = /*#__PURE__*/ gql`
    query getUserProfileMinimal {
  user {
    _id
    artistName
  }
}
    `;

/**
 * __useGetUserProfileMinimalQuery__
 *
 * To run a query within a React component, call `useGetUserProfileMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileMinimalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileMinimalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserProfileMinimalQueryData, GetUserProfileMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserProfileMinimalQueryData, GetUserProfileMinimalQueryVariables>(GetUserProfileMinimalDocument, options);
      }
export function useGetUserProfileMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserProfileMinimalQueryData, GetUserProfileMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserProfileMinimalQueryData, GetUserProfileMinimalQueryVariables>(GetUserProfileMinimalDocument, options);
        }
export function useGetUserProfileMinimalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserProfileMinimalQueryData, GetUserProfileMinimalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserProfileMinimalQueryData, GetUserProfileMinimalQueryVariables>(GetUserProfileMinimalDocument, options);
        }
export type GetUserProfileMinimalQueryHookResult = ReturnType<typeof useGetUserProfileMinimalQuery>;
export type GetUserProfileMinimalLazyQueryHookResult = ReturnType<typeof useGetUserProfileMinimalLazyQuery>;
export type GetUserProfileMinimalSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileMinimalSuspenseQuery>;
export type GetUserProfileMinimalQueryResult = Apollo.QueryResult<GetUserProfileMinimalQueryData, GetUserProfileMinimalQueryVariables>;
export const GetUserProfileRegisterDocument = /*#__PURE__*/ gql`
    query getUserProfileRegister {
  user {
    _id
    firstName
    lastName
    artistName
  }
}
    `;

/**
 * __useGetUserProfileRegisterQuery__
 *
 * To run a query within a React component, call `useGetUserProfileRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileRegisterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileRegisterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserProfileRegisterQueryData, GetUserProfileRegisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserProfileRegisterQueryData, GetUserProfileRegisterQueryVariables>(GetUserProfileRegisterDocument, options);
      }
export function useGetUserProfileRegisterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserProfileRegisterQueryData, GetUserProfileRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserProfileRegisterQueryData, GetUserProfileRegisterQueryVariables>(GetUserProfileRegisterDocument, options);
        }
export function useGetUserProfileRegisterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserProfileRegisterQueryData, GetUserProfileRegisterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserProfileRegisterQueryData, GetUserProfileRegisterQueryVariables>(GetUserProfileRegisterDocument, options);
        }
export type GetUserProfileRegisterQueryHookResult = ReturnType<typeof useGetUserProfileRegisterQuery>;
export type GetUserProfileRegisterLazyQueryHookResult = ReturnType<typeof useGetUserProfileRegisterLazyQuery>;
export type GetUserProfileRegisterSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileRegisterSuspenseQuery>;
export type GetUserProfileRegisterQueryResult = Apollo.QueryResult<GetUserProfileRegisterQueryData, GetUserProfileRegisterQueryVariables>;
export const GetUserSubscriptionDocument = /*#__PURE__*/ gql`
    query getUserSubscription {
  user {
    _id
    email
    firstName
    lastName
    subscription {
      tier
      status
      isActive
      daysUntilExpiry
      features {
        storageBytes
      }
      storageUsed
      storageLimit
      storagePercentageUsed
      projectBreakdown {
        projectId
        projectName
        storageUsed
        fileCount
      }
      stripeCustomerId
      currentPeriodStart
      currentPeriodEnd
      trialStart
      trialEnd
    }
  }
}
    `;

/**
 * __useGetUserSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetUserSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSubscriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserSubscriptionQueryData, GetUserSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserSubscriptionQueryData, GetUserSubscriptionQueryVariables>(GetUserSubscriptionDocument, options);
      }
export function useGetUserSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserSubscriptionQueryData, GetUserSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserSubscriptionQueryData, GetUserSubscriptionQueryVariables>(GetUserSubscriptionDocument, options);
        }
export function useGetUserSubscriptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserSubscriptionQueryData, GetUserSubscriptionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserSubscriptionQueryData, GetUserSubscriptionQueryVariables>(GetUserSubscriptionDocument, options);
        }
export type GetUserSubscriptionQueryHookResult = ReturnType<typeof useGetUserSubscriptionQuery>;
export type GetUserSubscriptionLazyQueryHookResult = ReturnType<typeof useGetUserSubscriptionLazyQuery>;
export type GetUserSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetUserSubscriptionSuspenseQuery>;
export type GetUserSubscriptionQueryResult = Apollo.QueryResult<GetUserSubscriptionQueryData, GetUserSubscriptionQueryVariables>;
export const UpdateUserProfileDocument = /*#__PURE__*/ gql`
    mutation updateUserProfile($data: UserUpdateInput!) {
  userUpdate(data: $data) {
    _id
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutationData, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserProfileMutationData, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserProfileMutationData, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutationData>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutationData, UpdateUserProfileMutationVariables>;
export const UserLoginDocument = /*#__PURE__*/ gql`
    mutation UserLogin($data: UserLoginInput!) {
  userLogin(data: $data) {
    token
    user {
      _id
      email
      firstName
      lastName
      artistName
      image
    }
  }
}
    `;
export type UserLoginMutationFn = Apollo.MutationFunction<UserLoginMutationData, UserLoginMutationVariables>;

/**
 * __useUserLoginMutation__
 *
 * To run a mutation, you first call `useUserLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userLoginMutation, { data, loading, error }] = useUserLoginMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUserLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserLoginMutationData, UserLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserLoginMutationData, UserLoginMutationVariables>(UserLoginDocument, options);
      }
export type UserLoginMutationHookResult = ReturnType<typeof useUserLoginMutation>;
export type UserLoginMutationResult = Apollo.MutationResult<UserLoginMutationData>;
export type UserLoginMutationOptions = Apollo.BaseMutationOptions<UserLoginMutationData, UserLoginMutationVariables>;
export const UserCreateDocument = /*#__PURE__*/ gql`
    mutation UserCreate($data: UserCreateInput!) {
  userCreate(data: $data) {
    token
    user {
      _id
      email
      firstName
      lastName
      artistName
      image
    }
  }
}
    `;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutationData, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserCreateMutationData, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserCreateMutationData, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutationData>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutationData, UserCreateMutationVariables>;
export const UserOAuthDocument = /*#__PURE__*/ gql`
    mutation UserOAuth($data: UserOAuthInput!) {
  userOAuth(data: $data) {
    token
    user {
      _id
      email
      firstName
      lastName
      artistName
      image
    }
  }
}
    `;
export type UserOAuthMutationFn = Apollo.MutationFunction<UserOAuthMutationData, UserOAuthMutationVariables>;

/**
 * __useUserOAuthMutation__
 *
 * To run a mutation, you first call `useUserOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userOAuthMutation, { data, loading, error }] = useUserOAuthMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUserOAuthMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserOAuthMutationData, UserOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserOAuthMutationData, UserOAuthMutationVariables>(UserOAuthDocument, options);
      }
export type UserOAuthMutationHookResult = ReturnType<typeof useUserOAuthMutation>;
export type UserOAuthMutationResult = Apollo.MutationResult<UserOAuthMutationData>;
export type UserOAuthMutationOptions = Apollo.BaseMutationOptions<UserOAuthMutationData, UserOAuthMutationVariables>;